import React, { useEffect, useState, useRef, createElement } from 'react';
import { Link } from 'react-router-dom';
import { Users, UsersRound, TrendingUp, Target, Award, Download, ChevronDown, ChevronUp, ChevronsUpDown, Filter, Calendar, ArrowUpRight, ArrowDownRight, Minus, Zap, MessageCircle, Send, ThumbsUp, AlertTriangle, TrendingDown, Clock, CheckCircle, Star, Mail, Video, Sparkles, BarChart3, Home, UserCog, FileText, Bell, X, RefreshCw, Search } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, Legend, ComposedChart } from 'recharts';
import { motion, AnimatePresence } from 'framer-motion';
import { AIInsightPopover } from './AIInsightPopover';
// Mock data for demonstration
const mockLearners = [{
  id: 1,
  name: 'Linda Taylor',
  email: 'linda.taylor@example.com',
  assessments: 3,
  avgScore: 85,
  lastAttempt: '2024-01-15'
}, {
  id: 2,
  name: 'John Smith',
  email: 'john.smith@example.com',
  assessments: 2,
  avgScore: 72,
  lastAttempt: '2024-01-14'
}, {
  id: 3,
  name: 'Sarah Johnson',
  email: 'sarah.j@example.com',
  assessments: 4,
  avgScore: 91,
  lastAttempt: '2024-01-16'
}, {
  id: 4,
  name: 'Michael Chen',
  email: 'mchen@example.com',
  assessments: 3,
  avgScore: 78,
  lastAttempt: '2024-01-13'
}, {
  id: 5,
  name: 'Emily Davis',
  email: 'emily.d@example.com',
  assessments: 2,
  avgScore: 88,
  lastAttempt: '2024-01-15'
}];
const moduleData = [{
  module: 'HTML Basics',
  mastery: 85,
  misinformation: 15,
  avgScore: 82,
  attempts: 45,
  confidentCorrect: 80,
  uncertainCorrect: 8,
  confidentIncorrect: 5,
  uncertainIncorrect: 7
}, {
  module: 'CSS Fundamentals',
  mastery: 78,
  misinformation: 22,
  avgScore: 76,
  attempts: 42,
  confidentCorrect: 75,
  uncertainCorrect: 10,
  confidentIncorrect: 8,
  uncertainIncorrect: 7
}, {
  module: 'JavaScript Basics',
  mastery: 72,
  misinformation: 28,
  avgScore: 71,
  attempts: 38,
  confidentCorrect: 65,
  uncertainCorrect: 10,
  confidentIncorrect: 15,
  uncertainIncorrect: 10
}, {
  module: 'Responsive Design',
  mastery: 80,
  misinformation: 20,
  avgScore: 79,
  attempts: 35,
  confidentCorrect: 78,
  uncertainCorrect: 10,
  confidentIncorrect: 6,
  uncertainIncorrect: 6
}];
const scoreDistribution = [{
  range: '0-20%',
  count: 2
}, {
  range: '21-40%',
  count: 5
}, {
  range: '41-60%',
  count: 8
}, {
  range: '61-80%',
  count: 15
}, {
  range: '81-100%',
  count: 12
}];
const attemptTrends = [{
  attempt: '1st',
  avgScore: 68
}, {
  attempt: '2nd',
  avgScore: 75
}, {
  attempt: '3rd',
  avgScore: 82
}, {
  attempt: '4th',
  avgScore: 86
}];
const individualModulePerformance = [{
  module: 'HTML Basics',
  score: 92,
  mastery: 95,
  misinformation: 5,
  attempts: 2,
  // Confidence breakdown data
  confidentCorrect: 80,
  uncertainCorrect: 8,
  confidentIncorrect: 5,
  uncertainIncorrect: 7
}, {
  module: 'CSS Fundamentals',
  score: 85,
  mastery: 88,
  misinformation: 12,
  attempts: 1,
  confidentCorrect: 75,
  uncertainCorrect: 10,
  confidentIncorrect: 8,
  uncertainIncorrect: 7
}, {
  module: 'JavaScript Basics',
  score: 78,
  mastery: 75,
  misinformation: 25,
  attempts: 3,
  confidentCorrect: 65,
  uncertainCorrect: 10,
  confidentIncorrect: 15,
  uncertainIncorrect: 10
}, {
  module: 'Responsive Design',
  score: 88,
  mastery: 90,
  misinformation: 10,
  attempts: 1,
  confidentCorrect: 78,
  uncertainCorrect: 10,
  confidentIncorrect: 6,
  uncertainIncorrect: 6
}];
const performanceTableData = [{
  name: 'David Hansen',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Chad Mundt',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Claudiu Budurlean',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Tiffany La Mertha',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '91.67%',
  confidentIncorrect: '0%'
}, {
  name: 'Uttam Parmar',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Jacob Zanders',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Jeevan Kandimalla',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Shannon Catt',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '100%',
  confidentIncorrect: '0%'
}, {
  name: 'Guna Bellampalli',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '83.33%',
  confidentIncorrect: '0%'
}, {
  name: 'Alexis Bensky',
  finalScore: '100%',
  improvement: '+0%',
  attempts: 1,
  confidentCorrect: '0%',
  confidentIncorrect: '0%'
}];
type PerformanceTableSortKey = 'name' | 'finalScore' | 'improvement' | 'attempts' | 'confidentCorrect' | 'confidentIncorrect';
// Action items mock data
const actionItems = [{
  id: 1,
  type: 'urgent',
  category: 'struggling',
  learner: {
    name: 'John Smith',
    email: 'john.smith@example.com',
    avatar: 'JS'
  },
  insight: 'Failed JavaScript Basics 3 times with declining scores',
  details: 'Score dropped from 68% → 65% → 58% over 3 attempts. High misinformation rate (45%) on core concepts.',
  module: 'JavaScript Basics',
  lastActivity: '2 days ago',
  priority: 'high',
  suggestedActions: ['Schedule 1-on-1 check-in', 'Recommend prerequisite review', 'Assign peer mentor']
}, {
  id: 2,
  type: 'macro',
  category: 'skill-issue',
  scope: 'system',
  insight: 'CSS Fundamentals has 68% failure rate across all learners',
  details: '42 of 62 learners (68%) are failing CSS Fundamentals on first attempt. Average score is 54%, well below the 70% passing threshold. Common struggle areas: Flexbox (82% error rate), Grid Layout (76% error rate), and Positioning (71% error rate).',
  module: 'CSS Fundamentals',
  affectedLearners: 42,
  lastActivity: 'Ongoing',
  priority: 'high',
  suggestedActions: ['Email the learners who are failing', 'Point learners to Flexbox and Grid practice', 'Schedule a group study session', 'Recommend how learners should prepare']
}, {
  id: 3,
  type: 'celebrate',
  category: 'high-performer',
  learner: {
    name: 'Sarah Johnson',
    email: 'sarah.j@example.com',
    avatar: 'SJ'
  },
  insight: 'Achieved 95%+ on all 4 assessments on first attempt',
  details: 'Consistent high performance with strong mastery across all modules. Completed skill 2 weeks ahead of schedule.',
  module: 'All Modules',
  lastActivity: '1 day ago',
  priority: 'positive',
  suggestedActions: ['Send congratulations', 'Invite to mentor program', 'Recommend advanced track']
}, {
  id: 4,
  type: 'macro',
  category: 'low-engagement',
  scope: 'system',
  insight: 'Responsive Design skill has only 12% enrollment rate',
  details: 'Only 30 of 248 active learners (12%) have started Responsive Design, despite it being a core requirement. Skill has been available for 45 days. Learners cite "intimidating title" and "unclear prerequisites" as barriers in feedback surveys.',
  module: 'Responsive Design',
  affectedLearners: 218,
  lastActivity: 'Last 45 days',
  priority: 'medium',
  suggestedActions: ['Send targeted enrollment emails', 'Show learners who have not started', 'Offer a short orientation session', 'Explain what to complete first']
}, {
  id: 5,
  type: 'attention',
  category: 'at-risk',
  learner: {
    name: 'Michael Chen',
    email: 'mchen@example.com',
    avatar: 'MC'
  },
  insight: 'No activity for 7 days, last score was 62%',
  details: 'Was on track but has been inactive. Last assessment showed struggle with CSS layouts.',
  module: 'CSS Fundamentals',
  lastActivity: '7 days ago',
  priority: 'medium',
  suggestedActions: ['Send check-in message', 'Point Michael to CSS layout practice', 'Extend deadline']
}, {
  id: 6,
  type: 'macro',
  category: 'content-gap',
  scope: 'system',
  insight: 'High misinformation rate (34%) on JavaScript async concepts',
  details: 'Across 156 attempts on JavaScript Basics, async/await and Promises questions show 34% misinformation rate (learners confidently selecting wrong answers). This is 2.8x higher than the skill average of 12%. Learners are attempting these questions before they have practiced the concepts.',
  module: 'JavaScript Basics',
  affectedLearners: 89,
  lastActivity: 'Last 30 days',
  priority: 'high',
  suggestedActions: ['Show the 89 learners affected', 'Draft a study nudge for these learners', 'Suggest what learners should review first', 'Schedule an async/await study session']
}, {
  id: 7,
  type: 'celebrate',
  category: 'improvement',
  learner: {
    name: 'Emily Davis',
    email: 'emily.d@example.com',
    avatar: 'ED'
  },
  insight: 'Improved from 65% to 88% after focused practice',
  details: 'Showed significant improvement on HTML Basics retake. Mastery increased from 60% to 92%.',
  module: 'HTML Basics',
  lastActivity: '1 day ago',
  priority: 'positive',
  suggestedActions: ['Send encouragement', 'Highlight progress', 'Share success story']
}, {
  id: 8,
  type: 'macro',
  category: 'success-pattern',
  scope: 'system',
  insight: 'HTML Basics pass rate is 23% higher where learners used the videos',
  details: 'Learners who watched the supplemental video tutorials passed HTML Basics on the first attempt 87% of the time, compared with 64% for those who did not. Average attempts dropped from 4.2 to 3.1. Learner feedback mentions "videos made concepts click" (mentioned in 78% of positive reviews).',
  module: 'HTML Basics',
  affectedLearners: 124,
  lastActivity: 'Last 3 weeks',
  priority: 'positive',
  suggestedActions: ['Point other learners to the video resources', 'Recognize the learners who improved most', 'Share what worked with struggling learners', 'Show which learners have not used the videos']
}, {
  id: 9,
  type: 'urgent',
  category: 'struggling',
  learner: {
    name: 'Alex Rivera',
    email: 'alex.r@example.com',
    avatar: 'AR'
  },
  insight: 'Consistently scoring below 50% across all modules',
  details: 'Attempted 5 assessments with average score of 45%. High misinformation rate suggests fundamental gaps.',
  module: 'Multiple Modules',
  lastActivity: '3 days ago',
  priority: 'high',
  suggestedActions: ['Schedule urgent meeting', 'Identify what is blocking Alex', 'Build a personal study plan']
}, {
  id: 10,
  type: 'macro',
  category: 'time-pattern',
  scope: 'system',
  insight: 'Weekend attempts have 41% higher failure rate than weekday',
  details: 'Analysis of 892 assessment attempts shows weekend attempts (Sat-Sun) have 41% higher failure rate (58% vs 41%). Possible causes: less instructor support available, learners rushing through content, or fatigue from weekday work. Pattern consistent across all skills.',
  module: 'All Skills',
  affectedLearners: 187,
  lastActivity: 'Last 60 days',
  priority: 'medium',
  suggestedActions: ['Send "take your time" reminders on Fridays', 'Show learners who attempt on weekends', 'Offer weekend check-in support', 'Encourage learners to attempt when support is available']
}, {
  id: 11,
  type: 'attention',
  category: 'engagement',
  learner: {
    name: 'Lisa Wong',
    email: 'lisa.w@example.com',
    avatar: 'LW'
  },
  insight: 'Taking unusually long between attempts (10+ days)',
  details: 'Scores are adequate (75% avg) but engagement pattern suggests time management issues.',
  module: 'Responsive Design',
  lastActivity: '5 days ago',
  priority: 'medium',
  suggestedActions: ['Check on progress', 'Offer time management tips', 'Discuss barriers']
}];
export function AnalyticsDashboard() {
  const [selectedLearner, setSelectedLearner] = useState<number | null>(null);
  const [isLearnerDropdownOpen, setIsLearnerDropdownOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState<string>('All Skills Combined');
  const [isSkillDropdownOpen, setIsSkillDropdownOpen] = useState(false);
  const [selectedChartType, setSelectedChartType] = useState<string>('Score Distribution');
  const [isChartTypeDropdownOpen, setIsChartTypeDropdownOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'assessment' | 'progress'>('assessment');
  const userMenuRef = useRef<HTMLDivElement>(null);
  const skillDropdownRef = useRef<HTMLDivElement>(null);
  const learnerDropdownRef = useRef<HTMLDivElement>(null);
  const chartTypeDropdownRef = useRef<HTMLDivElement>(null);
  // Let the Phoebe walkthrough drive which analytics tab is showing
  useEffect(() => {
    const handleTourTab = (event: Event) => {
      const requestedTab = (event as CustomEvent<'assessment' | 'progress'>).detail;
      if (requestedTab === 'assessment' || requestedTab === 'progress') {
        setActiveTab(requestedTab);
      }
    };
    window.addEventListener('phoebe:analytics-tab', handleTourTab);
    return () => window.removeEventListener('phoebe:analytics-tab', handleTourTab);
  }, []);
  const skillOptions = ['All Skills Combined', 'HTML Basics', 'CSS Fundamentals', 'JavaScript Basics', 'Responsive Design'];
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
      if (skillDropdownRef.current && !skillDropdownRef.current.contains(event.target as Node)) {
        setIsSkillDropdownOpen(false);
      }
      if (learnerDropdownRef.current && !learnerDropdownRef.current.contains(event.target as Node)) {
        setIsLearnerDropdownOpen(false);
      }
      if (chartTypeDropdownRef.current && !chartTypeDropdownRef.current.contains(event.target as Node)) {
        setIsChartTypeDropdownOpen(false);
      }
    };
    if (isUserMenuOpen || isSkillDropdownOpen || isLearnerDropdownOpen || isChartTypeDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen, isSkillDropdownOpen, isLearnerDropdownOpen, isChartTypeDropdownOpen]);
  const totalLearners = mockLearners.length;
  const totalAssessments = mockLearners.reduce((sum, l) => sum + l.assessments, 0);
  const overallAvgScore = Math.round(mockLearners.reduce((sum, l) => sum + l.avgScore, 0) / totalLearners);
  const overallMastery = Math.round(moduleData.reduce((sum, m) => sum + m.mastery, 0) / moduleData.length);
  // Derive viewMode from state
  const viewMode = selectedLearner ? 'individual' : 'aggregate';
  const selectedLearnerData = selectedLearner ? mockLearners.find(l => l.id === selectedLearner) : null;
  const COLORS = ['#30718D', '#007558', '#FBBC04', '#DB3725'];
  return <div className="flex-1 bg-gray-50 min-h-screen" data-id="element-245" data-mp="1hy4h6xh1ahpj">
      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-246" data-mp="1lxmsd1j1zef6">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247" data-mp="1qy9egesijzpz">
          <div className="flex items-center h-16" data-id="element-248" data-mp="1qvwp3gkfen2w">
            {/* Logo */}
            <div className="text-[#DB3725] font-bold text-xl" data-id="element-249" data-mp="1vxlx0nccqkmr">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-250" data-mp="262c6rfdzyt1j">
              <Link data-phoebe-nav="/admin" to="/admin" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-251" data-mp="2116dnggfd3rh">
                <Home size={18} data-id="element-252" data-mp="1s3cjoc64um7h" />
                <span className="hidden sm:inline" data-id="element-253" data-mp="2os1zlwy794qt">Admin Hub</span>
              </Link>
              <Link data-phoebe-nav="/analytics" to="/analytics" className="flex items-center gap-2 text-[#30718D] border-b-2 border-[#30718D] pb-[22px] pt-[22px] transition-colors text-sm font-medium" data-id="element-254" data-mp="2jspd5db8pzor">
                <BarChart3 size={18} data-id="element-255" data-mp="2azvlshiir9uj" />
                <span className="hidden sm:inline" data-id="element-256" data-mp="37hrv6m9sdujs">Analytics</span>
              </Link>
              <Link data-phoebe-nav="/feedback" to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-257" data-mp="32rbfswmenyus">
                <FileText size={18} data-id="element-258" data-mp="3r73ro6zjuxpw" />
                <span className="hidden sm:inline" data-id="element-259" data-mp="3r853wesaxq97">Reports</span>
              </Link>
              <Link data-phoebe-nav="/assessment" to="/assessment" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-260" data-mp="3cipd4ysrtkti">
                <UserCog size={18} data-id="element-261" data-mp="dzilrkxstmka" />
                <span className="hidden sm:inline" data-id="element-262" data-mp="dyh7l7lhkjyc">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-263" data-mp="3va03neul3vkv">
              <Link to="/alerts" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-264" data-mp="3zrojbhustgi">
                <Bell size={20} data-id="element-265" data-mp="2os38zilw0kos" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-266" data-mp="2ot4w4lg6gxmv"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-267" data-mp="16s3zj5597uez">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-268" data-mp="11tsm6kfr31s0">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-269" data-mp="1btjj0srs9sv9">
                    LT
                  </div>
                  <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-270" data-mp="j5f9txa06xnt">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-271" data-mp="wxlrxowpvepw" />
                </button>

                {/* User Dropdown Menu */}
                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-272" data-mp="4dn6ykrebc2z">
                    <div className="py-2" data-id="element-273" data-mp="2ql2wwob4s8o6">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-274" data-mp="2qm4hpkhy89j3">
                        <Users size={18} className="text-gray-600" data-id="element-275" data-mp="30c7abjl5rlgw" />
                        <span className="font-medium text-gray-900" data-id="element-276" data-mp="2vj4qi366nqdw">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-277" data-mp="359zd58nccrzv">
                        <Home size={18} className="text-gray-600" data-id="element-278" data-mp="3j8pc6ttq11qv" />
                        <span className="font-medium text-gray-900" data-id="element-279" data-mp="3eax9d4rjfv7w">
                          Learner Hub
                        </span>
                      </button>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-280" data-mp="1oxtsowh0029b">
                        <UserCog size={18} className="text-gray-600" data-id="element-281" data-mp="3vjhpwf3deoi7" />
                        <span className="font-medium text-gray-900" data-id="element-282" data-mp="3vmcac6mdw9bm">
                          Admin Hub
                        </span>
                      </button>
                      <div className="border-t border-gray-200 my-2" data-id="element-283" data-mp="3mr69lm1z0hfy"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-284" data-mp="3qs809ehtnl6b">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-285" data-mp="3cvl3pcts6x0x">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-286" data-mp="163by0j2rdj3o"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-287" data-mp="2f0ig6ta7lxnn"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-288" data-mp="2exmjf8a3lf0s"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-289" data-mp="2a38t3kaaly2z">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <div data-phoebe-tour="analytics" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 pb-4" data-id="element-290" data-mp="2tod9obw1k61s">
        <div data-id="element-291" data-mp="2oxdd57qu3pzt">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900" data-id="element-292" data-mp="2owvkel3drtwn">
            Analytics Dashboard
          </h1>
          <p className="text-gray-600 mt-1 text-sm sm:text-base" data-id="element-293" data-mp="2jytqf54f2a6e">
            Track learner progress and assessment performance
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div data-phoebe-tour="analytics-tabs" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294" data-mp="3cm6ddgehok08">
        <div className="border-b border-gray-200 flex items-center" data-id="element-295" data-mp="3k0gq8cvxiski">
          <button data-phoebe-nav="analytics-tab-assessment" onClick={() => setActiveTab('assessment')} className={`relative px-4 sm:px-6 py-3 text-sm sm:text-base font-bold transition-colors ${activeTab === 'assessment' ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-296" data-mp="3ox75ixzwtk4v">
            Assessment Analytics
            {activeTab === 'assessment' && <span className="absolute left-0 right-0 -bottom-px h-1 bg-[#DB3725]" data-id="element-297" data-mp="bqf5lapamugc"></span>}
          </button>
          <button data-phoebe-nav="analytics-tab-progress" onClick={() => setActiveTab('progress')} className={`relative px-4 sm:px-6 py-3 text-sm sm:text-base font-bold transition-colors ${activeTab === 'progress' ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-298" data-mp="giozf1tj4enw">
            Learner Progress
            {activeTab === 'progress' && <span className="absolute left-0 right-0 -bottom-px h-1 bg-[#DB3725]" data-id="element-299" data-mp="gtoeizbqq087"></span>}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-6" data-id="element-300" data-mp="qjzhaijou3di">
        {activeTab === 'progress' ? <LearnerProgressTable data-id="element-301" data-mp="lmhivm3ar6jr" /> : viewMode === 'aggregate' ? <AggregateView totalLearners={totalLearners} totalAssessments={totalAssessments} overallAvgScore={overallAvgScore} overallMastery={overallMastery} moduleData={moduleData} scoreDistribution={scoreDistribution} attemptTrends={attemptTrends} COLORS={COLORS} selectedSkill={selectedSkill} setSelectedSkill={setSelectedSkill} isSkillDropdownOpen={isSkillDropdownOpen} setIsSkillDropdownOpen={setIsSkillDropdownOpen} skillDropdownRef={skillDropdownRef} skillOptions={skillOptions} selectedLearner={selectedLearner} setSelectedLearner={setSelectedLearner} selectedLearnerData={selectedLearnerData} isLearnerDropdownOpen={isLearnerDropdownOpen} setIsLearnerDropdownOpen={setIsLearnerDropdownOpen} learnerDropdownRef={learnerDropdownRef} data-id="element-302" data-mp="3u0zm9aialxx1" /> : selectedLearnerData ? <IndividualView learner={selectedLearnerData} modulePerformance={individualModulePerformance} actionItems={actionItems} COLORS={COLORS} selectedSkill={selectedSkill} setSelectedSkill={setSelectedSkill} isSkillDropdownOpen={isSkillDropdownOpen} setIsSkillDropdownOpen={setIsSkillDropdownOpen} skillDropdownRef={skillDropdownRef} skillOptions={skillOptions} selectedLearner={selectedLearner} setSelectedLearner={setSelectedLearner} selectedLearnerData={selectedLearnerData} isLearnerDropdownOpen={isLearnerDropdownOpen} setIsLearnerDropdownOpen={setIsLearnerDropdownOpen} learnerDropdownRef={learnerDropdownRef} data-id="element-303" data-mp="3fwr42m60j6wb" /> : <div className="bg-white rounded-xl p-12 text-center shadow-sm border border-gray-100" data-id="element-304" data-mp="2f5fo0ksol7s">
            <Users size={48} className="mx-auto text-gray-400 mb-4" data-id="element-305" data-mp="3uixz543g7zjp" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-306" data-mp="3uk92x3ww97at">
              Select a Learner
            </h3>
            <p className="text-gray-600" data-id="element-307" data-mp="3pqd4y1gmrkfn">
              Choose a learner from the dropdown above to view their individual
              performance
            </p>
          </div>}
      </div>
    </div>;
}
const learnerProgressData = [{
  name: 'Alexis Bensky',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 1,
  firstScore: '91.67%',
  finalScore: '91.67%',
  improvement: '+0%',
  ccFirst: '0%',
  ccFinal: '0%'
}, {
  name: 'Alexis Bensky',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '0%',
  ccFinal: '0%'
}, {
  name: 'Alexis Bensky',
  module: 'Leading with Effective Communication',
  attempts: 3,
  firstScore: '75%',
  finalScore: '100%',
  improvement: '+25%',
  ccFirst: '0%',
  ccFinal: '0%'
}, {
  name: 'Chad Mundt',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Claudiu Budurlean',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Cora Asher',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 1,
  firstScore: '75%',
  finalScore: '75%',
  improvement: '+0%',
  ccFirst: '75%',
  ccFinal: '75%'
}, {
  name: 'David Hansen',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Guna Bellampalli',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '83.33%',
  ccFinal: '83.33%'
}, {
  name: 'Jacob Zanders',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 2,
  firstScore: '83.33%',
  finalScore: '100%',
  improvement: '+16.67%',
  ccFirst: '83.33%',
  ccFinal: '100%'
}, {
  name: 'Jacob Zanders',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Jacob Zanders',
  module: 'Leading with Effective Communication',
  attempts: 3,
  firstScore: '83.33%',
  finalScore: '100%',
  improvement: '+16.67%',
  ccFirst: '83.33%',
  ccFinal: '100%'
}, {
  name: 'Maya Patel',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 2,
  firstScore: '66.67%',
  finalScore: '91.67%',
  improvement: '+25%',
  ccFirst: '50%',
  ccFinal: '83.33%'
}, {
  name: 'Maya Patel',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '100%',
  ccFinal: '100%'
}, {
  name: 'Noah Williams',
  module: 'Leading with Effective Communication',
  attempts: 2,
  firstScore: '75%',
  finalScore: '91.67%',
  improvement: '+16.67%',
  ccFirst: '66.67%',
  ccFinal: '83.33%'
}, {
  name: 'Olivia Brown',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 1,
  firstScore: '83.33%',
  finalScore: '83.33%',
  improvement: '+0%',
  ccFirst: '83.33%',
  ccFinal: '83.33%'
}, {
  name: 'Olivia Brown',
  module: 'Giving and Receiving Feedback',
  attempts: 3,
  firstScore: '58.33%',
  finalScore: '91.67%',
  improvement: '+33.34%',
  ccFirst: '41.67%',
  ccFinal: '75%'
}, {
  name: 'Priya Shah',
  module: 'Leading with Effective Communication',
  attempts: 1,
  firstScore: '100%',
  finalScore: '100%',
  improvement: '+0%',
  ccFirst: '91.67%',
  ccFinal: '91.67%'
}, {
  name: 'Quinn Rivera',
  module: 'Empathetic Communication and Emotional Management',
  attempts: 2,
  firstScore: '75%',
  finalScore: '100%',
  improvement: '+25%',
  ccFirst: '66.67%',
  ccFinal: '100%'
}, {
  name: 'Rachel Kim',
  module: 'Giving and Receiving Feedback',
  attempts: 1,
  firstScore: '91.67%',
  finalScore: '91.67%',
  improvement: '+0%',
  ccFirst: '83.33%',
  ccFinal: '83.33%'
}, {
  name: 'Samuel Okafor',
  module: 'Leading with Effective Communication',
  attempts: 3,
  firstScore: '50%',
  finalScore: '83.33%',
  improvement: '+33.33%',
  ccFirst: '33.33%',
  ccFinal: '66.67%'
}];
type LearnerProgressSortKey = 'name' | 'module' | 'attempts' | 'firstScore' | 'finalScore' | 'improvement' | 'ccFirst' | 'ccFinal';
function parsePercent(value: string | number) {
  if (typeof value === 'number') return value;
  const cleaned = value.replace('%', '').replace('+', '').trim();
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
}
function LearnerProgressTable() {
  const [showDetails, setShowDetails] = useState(true);
  const [sortKey, setSortKey] = useState<LearnerProgressSortKey>('name');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const [moduleFilter, setModuleFilter] = useState<string>('All Modules');
  const [moduleSearch, setModuleSearch] = useState<string>('');
  const [isModuleDropdownOpen, setIsModuleDropdownOpen] = useState(false);
  const [isPaginationDropdownOpen, setIsPaginationDropdownOpen] = useState(false);
  const moduleDropdownRef = useRef<HTMLDivElement>(null);
  const paginationDropdownRef = useRef<HTMLDivElement>(null);
  const itemsPerPage = 10;
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (moduleDropdownRef.current && !moduleDropdownRef.current.contains(event.target as Node)) {
        setIsModuleDropdownOpen(false);
      }
      if (paginationDropdownRef.current && !paginationDropdownRef.current.contains(event.target as Node)) {
        setIsPaginationDropdownOpen(false);
      }
    };
    if (isModuleDropdownOpen || isPaginationDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModuleDropdownOpen, isPaginationDropdownOpen]);
  const handleSort = (key: LearnerProgressSortKey) => {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
    setCurrentPage(1);
  };
  const moduleFilteredData = moduleFilter === 'All Modules' ? learnerProgressData : learnerProgressData.filter(r => r.module === moduleFilter);
  const sortedData = [...moduleFilteredData].sort((a, b) => {
    let valA: string | number = a[sortKey];
    let valB: string | number = b[sortKey];
    if (sortKey === 'attempts' || sortKey === 'firstScore' || sortKey === 'finalScore' || sortKey === 'improvement' || sortKey === 'ccFirst' || sortKey === 'ccFinal') {
      const numA = parsePercent(valA as any);
      const numB = parsePercent(valB as any);
      return sortDir === 'asc' ? numA - numB : numB - numA;
    }
    const strA = String(valA).toLowerCase();
    const strB = String(valB).toLowerCase();
    return sortDir === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
  });
  const totalPages = Math.max(1, Math.ceil(sortedData.length / itemsPerPage));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const paginatedData = sortedData.slice((safeCurrentPage - 1) * itemsPerPage, safeCurrentPage * itemsPerPage);
  const isActive = (key: LearnerProgressSortKey) => sortKey === key;
  const SortArrow = ({
    columnKey
  }: {
    columnKey: LearnerProgressSortKey;
  }) => {
    if (!isActive(columnKey)) {
      return <ChevronsUpDown size={14} className="text-gray-400" data-id="element-308" data-mp="cmca8coxpq9x" />;
    }
    return sortDir === 'asc' ? <ChevronUp size={14} className="text-[#30718D]" data-id="element-309" data-mp="he42crnqo426" /> : <ChevronDown size={14} className="text-[#30718D]" data-id="element-310" data-mp="hff5cp9d17s8" />;
  };
  const headerBtnClass = (columnKey: LearnerProgressSortKey) => `flex items-center gap-1 text-left text-sm font-medium transition-colors ${isActive(columnKey) ? 'text-[#30718D]' : 'text-gray-700 hover:text-gray-900'}`;
  const cellActiveClass = (columnKey: LearnerProgressSortKey) => isActive(columnKey) ? 'bg-[#30718D]/5' : '';
  const headerActiveClass = (columnKey: LearnerProgressSortKey) => isActive(columnKey) ? 'bg-[#30718D]/10' : '';
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-visible" data-id="element-311" data-mp="2zjn8yksspd8i">
      {/* Header */}
      <div data-phoebe-tour="learner-progress-header" className="px-4 sm:px-6 py-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 overflow-visible" data-id="element-312" data-mp="2ukk4b1gq9912">
        <div data-id="element-313" data-mp="2kv8zhr0viqiz">
          <div className="flex items-center gap-2" data-id="element-314" data-mp="2kv0oy5s83xay">
            <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-315" data-mp="2fvwdt9lqnphz">
              <UsersRound size={22} className="text-[#30718D]" data-id="element-316" data-mp="2btj6igrcfjj3" />
              Detailed Summary Table by Learner
            </h4>
            <AIInsightPopover align="left" headline="Retakes are working — first attempts are the gap" insightBeforeMetric="Learners who retook a module improved by an average of" highlightedMetric="21 points" insightAfterMetric=", but most only pass on a later attempt." explanation="Leading with Effective Communication needs the most attempts, so earlier practice there would reduce retakes." insightId={15} data-id="element-317" data-mp="26vr9j8bud781" />
          </div>
          <p className="text-sm text-gray-500 ml-[26px]" data-id="element-318" data-mp="2fzodslkk9s5u">
            Individual learner performance metrics by skill module
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3" data-id="element-319" data-mp="266qu4c3u1x5n">
          {/* Skill module search dropdown */}
          <div className="relative" ref={moduleDropdownRef} data-id="element-320" data-mp="2b4sauqdsdkdy">
            <button type="button" onClick={() => {
            setIsModuleDropdownOpen(!isModuleDropdownOpen);
            setModuleSearch('');
          }} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[240px]" data-id="element-321" data-mp="2yvnzjemy3zgz">
              <Target size={16} className="text-[#30718D]" data-id="element-322" data-mp="10zzd5bdej2e6" />
              <span className="flex-1 text-left truncate" data-id="element-323" data-mp="wydu18a9xrvj">{moduleFilter}</span>
              <ChevronDown size={16} className={`transition-transform text-gray-500 ${isModuleDropdownOpen ? 'rotate-180' : ''}`} data-id="element-324" data-mp="99bec5z7a93o" />
            </button>

            {isModuleDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full sm:w-[320px] bg-white border border-gray-200 rounded-lg shadow-lg z-20" data-id="element-325" data-mp="ib2fcxisprr7">
                <div className="p-2 border-b border-gray-100" data-id="element-326" data-mp="dd0wodpa7ug9">
                  <div className="relative" data-id="element-327" data-mp="1tnv562s1064m">
                    <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-328" data-mp="1oq3gdhmoh04n" />
                    <input type="text" autoFocus value={moduleSearch} onChange={e => setModuleSearch(e.target.value)} placeholder="Search skill modules..." className="w-full pl-8 pr-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D]/40 focus:border-[#30718D]" data-id="element-329" data-mp="28qd2jcna9ehs" />
                  </div>
                </div>
                <div className="max-h-64 overflow-y-auto py-1" data-id="element-330" data-mp="31gvfr6hq0w8x">
                  {(() => {
                const uniqueModules = Array.from(new Set(learnerProgressData.map(r => r.module))).sort((a, b) => a.localeCompare(b));
                const options = ['All Modules', ...uniqueModules];
                const q = moduleSearch.trim().toLowerCase();
                const filtered = q ? options.filter(n => n.toLowerCase().includes(q)) : options;
                if (filtered.length === 0) {
                  return <div className="px-4 py-3 text-sm text-gray-500" data-id="element-331" data-mp="tw4zqa8plj9o">
                          No skill modules found
                        </div>;
                }
                return filtered.map(name => <button key={name} onClick={() => {
                  setModuleFilter(name);
                  setIsModuleDropdownOpen(false);
                  setModuleSearch('');
                  setCurrentPage(1);
                }} className={`w-full px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm ${moduleFilter === name ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-332" data-mp="1mhenpbznipmn">
                        {name}
                      </button>);
              })()}
                </div>
              </div>}
          </div>

          <button type="button" className="self-start sm:self-auto flex items-center gap-2 px-4 py-2 bg-[#DB3725] text-white text-sm font-medium rounded-lg hover:bg-[#c02f1f] transition-colors" data-id="element-333" data-mp="3cpjccjpgilvc">
            <Download size={16} data-id="element-334" data-mp="32sof044x6rin" />
            Download
          </button>
        </div>
      </div>

      {/* Table */}
      {showDetails && <div className="overflow-x-auto" data-id="element-335" data-mp="2tzkx9jn8rsi7">
          <table className="w-full text-sm" data-id="element-336" data-mp="2u0mgwcibpnbj">
            <thead data-id="element-337" data-mp="2tx71f8kqmc9l">
              <tr className="border-b border-gray-200 bg-gray-50" data-id="element-338" data-mp="2p0qfml10g9zo">
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('name')}`} data-id="element-339" data-mp="2oydpvlp0gvc2">
                  <button onClick={() => handleSort('name')} className={headerBtnClass('name')} data-id="element-340" data-mp="2f3lpyb7yhwe4">
                    Learner Name
                    <SortArrow columnKey="name" data-id="element-341" data-mp="29wfafsjembcx" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('module')}`} data-id="element-342" data-mp="2ew9x1jw5ces6">
                  <button onClick={() => handleSort('module')} className={headerBtnClass('module')} data-id="element-343" data-mp="1m7w3phg066my">
                    Skill Module
                    <SortArrow columnKey="module" data-id="element-344" data-mp="1w622hq6iiwnl" />
                  </button>
                </th>
                <th data-phoebe-tour="learner-progress-scores" className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('attempts')}`} data-id="element-345" data-mp="20ws6p037ctgp">
                  <button onClick={() => handleSort('attempts')} className={headerBtnClass('attempts')} data-id="element-346" data-mp="18fo7bqsmshos">
                    Attempts
                    <SortArrow columnKey="attempts" data-id="element-347" data-mp="vh8dsyfczxql" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('firstScore')}`} data-id="element-348" data-mp="1a64gefyncijt">
                  <button onClick={() => handleSort('firstScore')} className={headerBtnClass('firstScore')} data-id="element-349" data-mp="158ul4joktco2">
                    First Score
                    <SortArrow columnKey="firstScore" data-id="element-350" data-mp="ck71esjh6vcm" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('finalScore')}`} data-id="element-351" data-mp="mg0d69pdektc">
                  <button onClick={() => handleSort('finalScore')} className={headerBtnClass('finalScore')} data-id="element-352" data-mp="22sfhdrq60lh5">
                    Final Score
                    <SortArrow columnKey="finalScore" data-id="element-353" data-mp="25ddhbbcagboi" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('improvement')}`} data-id="element-354" data-mp="2af2qelfyaf9y">
                  <button onClick={() => handleSort('improvement')} className={headerBtnClass('improvement')} data-id="element-355" data-mp="20gd9ovzsj0va">
                    Improvement
                    <SortArrow columnKey="improvement" data-id="element-356" data-mp="2t2y1tyo3bgzw" />
                  </button>
                </th>
                <th data-phoebe-tour="learner-progress-confidence" className={`text-left px-4 sm:px-6 py-3 max-w-[160px] transition-colors ${headerActiveClass('ccFirst')}`} data-id="element-357" data-mp="2fc2wuxgppk1l">
                  <button onClick={() => handleSort('ccFirst')} className={`${headerBtnClass('ccFirst')} items-start text-left`} data-id="element-358" data-mp="371xq357oxtvj">
                    <span className="leading-snug" data-id="element-359" data-mp="1o7qj5e09rrdi">
                      Confident & Correct Rate First Attempt
                    </span>
                    <SortArrow columnKey="ccFirst" data-id="element-360" data-mp="1e7zu3ruha4kt" />
                  </button>
                </th>
                <th className={`text-left px-4 sm:px-6 py-3 max-w-[160px] transition-colors ${headerActiveClass('ccFinal')}`} data-id="element-361" data-mp="1a6xrr259lcem">
                  <button onClick={() => handleSort('ccFinal')} className={`${headerBtnClass('ccFinal')} items-start text-left`} data-id="element-362" data-mp="26z199sy6804c">
                    <span className="leading-snug" data-id="element-363" data-mp="1x5aqn4oq6jwk">
                      Confident & Correct Rate Final Attempt
                    </span>
                    <SortArrow columnKey="ccFinal" data-id="element-364" data-mp="2pn6aotrcv8zz" />
                  </button>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-365" data-mp="2kvwltvdms9p5">
              {paginatedData.map((row, idx) => <tr key={idx} className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors" data-id="element-366" data-mp="7elf7427u3e1" data-mpi={idx}>
                  <td className={`px-4 sm:px-6 py-4 font-medium text-gray-900 align-middle whitespace-nowrap transition-colors ${cellActiveClass('name')}`} data-id="element-367" data-mp="ceznmn7qbfcl">
                    {row.name}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle transition-colors ${cellActiveClass('module')}`} data-id="element-368" data-mp="qc4sijvpi869">
                    {row.module}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums transition-colors ${cellActiveClass('attempts')}`} data-id="element-369" data-mp="103iwp4ylrw5q">
                    {row.attempts}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('firstScore')}`} data-id="element-370" data-mp="1e28tsklf9vu3">
                    {row.firstScore}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('finalScore')}`} data-id="element-371" data-mp="354h76tugv9kz">
                    {row.finalScore}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('improvement')}`} data-id="element-372" data-mp="3sv3geog7izwk">
                    {row.improvement}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums max-w-[160px] transition-colors ${cellActiveClass('ccFirst')}`} data-id="element-373" data-mp="1q3bc5yei2ls">
                    {row.ccFirst}
                  </td>
                  <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums max-w-[160px] transition-colors ${cellActiveClass('ccFinal')}`} data-id="element-374" data-mp="23irkevxq7k9h">
                    {row.ccFinal}
                  </td>
                </tr>)}
            </tbody>
          </table>

          {/* Pagination */}
          {sortedData.length > 0 && <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-t border-gray-200" data-id="element-375" data-mp="e6uwryg80wn2">
              <p className="text-sm text-gray-600" data-id="element-376" data-mp="7d3b5rzcv7d">
                Showing {(safeCurrentPage - 1) * itemsPerPage + 1}–
                {Math.min(safeCurrentPage * itemsPerPage, sortedData.length)} of{' '}
                {sortedData.length}
              </p>
              <div className="flex items-center gap-2" data-id="element-377" data-mp="3re63c6b1eoab">
                <span className="text-sm text-gray-600" data-id="element-378" data-mp="3rh2402e9rr2g">Page</span>
                <div className="relative" ref={paginationDropdownRef} data-id="element-379" data-mp="1kpt4g4phv43i">
                  <button type="button" onClick={() => setIsPaginationDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isPaginationDropdownOpen} aria-label="Select page" className={`flex min-w-14 items-center justify-between rounded-md border bg-white py-1 pl-2 pr-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${isPaginationDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 text-[#30718D]' : 'border-gray-300 text-gray-700'}`} data-id="element-380" data-mp="1pnunwqqu15fi">
                    <span data-id="element-381" data-mp="3lsrfzzryyfda">{safeCurrentPage}</span>
                    <ChevronDown size={14} aria-hidden="true" className={`ml-2 text-gray-400 transition-transform ${isPaginationDropdownOpen ? 'rotate-180' : ''}`} data-id="element-382" data-mp="3gu6bvp9ljbjk" />
                  </button>
                  {isPaginationDropdownOpen && <div role="listbox" aria-label="Select page" className="absolute bottom-full z-30 mb-1 max-h-60 min-w-full overflow-y-auto overflow-x-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-383" data-mp="1a51hsdydbvn0">
                      {Array.from({
                length: totalPages
              }, (_, i) => i + 1).map(page => <button key={page} type="button" role="option" aria-selected={safeCurrentPage === page} onClick={() => {
                setCurrentPage(page);
                setIsPaginationDropdownOpen(false);
              }} className={`flex w-full items-center border-b border-gray-100 px-3 py-2 text-left text-sm transition-colors last:border-b-0 ${safeCurrentPage === page ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-384" data-mp="yr9lek5hxq72">
                          {page}
                        </button>)}
                    </div>}
                </div>
                <span className="text-sm text-gray-600" data-id="element-385" data-mp="38y5xp2p1jo0j">of {totalPages}</span>
              </div>
            </div>}
        </div>}
    </div>;
}
function ActionItemsView({
  actionItems,
  selectedSkill
}) {
  const [activeFilter, setActiveFilter] = useState<'all' | 'urgent' | 'attention' | 'celebrate'>('all');
  const [selectedAction, setSelectedAction] = useState<number | null>(null);
  const [viewType, setViewType] = useState<'all' | 'individual' | 'macro'>('all');
  // Modal states
  const [messageModal, setMessageModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [meetingModal, setMeetingModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [kudosModal, setKudosModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  // Filter action items by selected skill
  const skillFilteredItems = selectedSkill === 'All Skills Combined' ? actionItems : actionItems.filter(item => item.module === selectedSkill || item.module === 'All Modules' || item.module === 'All Skills' || item.module === 'Multiple Modules');
  const filteredItems = skillFilteredItems.filter(item => {
    // Filter by view type
    if (viewType === 'individual' && item.type === 'macro') return false;
    if (viewType === 'macro' && item.type !== 'macro') return false;
    // Filter by priority
    if (activeFilter === 'all') return true;
    if (activeFilter === 'urgent') return item.priority === 'high';
    if (activeFilter === 'attention') return item.priority === 'medium';
    if (activeFilter === 'celebrate') return item.priority === 'positive';
    return true;
  });
  const urgentCount = skillFilteredItems.filter(a => a.priority === 'high').length;
  const attentionCount = skillFilteredItems.filter(a => a.priority === 'medium').length;
  const celebrateCount = skillFilteredItems.filter(a => a.priority === 'positive').length;
  const macroCount = skillFilteredItems.filter(a => a.type === 'macro').length;
  const individualCount = skillFilteredItems.filter(a => a.type !== 'macro').length;
  // Get recipient name for modals
  const getRecipientName = (item: any) => {
    if (item.learner) return item.learner.name;
    return 'Team';
  };
  const getRecipientFirstName = (item: any) => {
    if (item.learner) return item.learner.name.split(' ')[0];
    return 'Team';
  };
  return <div data-id="element-386" data-mp="cml3tacqpbnl">
      {/* Message Modal */}
      <AnimatePresence data-id="element-387" data-mp="cnmfnh1ky26d">
        {messageModal.isOpen && messageModal.item && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setMessageModal({
        isOpen: false,
        item: null
      })} data-id="element-388" data-mp="1x66nmtwdvtc6">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full" onClick={e => e.stopPropagation()} data-id="element-389" data-mp="2btrr4ox67ukm">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-390" data-mp="2ecbp27thfs4l">
                <div className="flex items-center gap-3" data-id="element-391" data-mp="2je119qsfybu9">
                  <div className="w-12 h-12 rounded-lg bg-[#30718D] flex items-center justify-center" data-id="element-392" data-mp="25dq8gi7kmn6g">
                    <Mail size={24} className="text-white" data-id="element-393" data-mp="2ab9o9mjx380i" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-394" data-mp="2y13xzv8xwggj">
                    Send Message
                  </h2>
                </div>
                <button onClick={() => setMessageModal({
              isOpen: false,
              item: null
            })} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-395" data-mp="322pkm8ba093x">
                  <X size={20} className="text-gray-500" data-id="element-396" data-mp="3gz6tmsvztbnb" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-397" data-mp="3v5ryu8sw137y">
                <p className="text-gray-600 mb-1" data-id="element-398" data-mp="3v4yrb5m3u9or">
                  Your message has been successfully sent to
                </p>
                <p className="text-lg font-bold text-gray-900 mb-6" data-id="element-399" data-mp="3r2c4jj4ajeyf">
                  {getRecipientName(messageModal.item)}
                </p>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-400" data-mp="3qudyyhymm5k">
                  <p className="text-sm text-gray-500 mb-2" data-id="element-401" data-mp="3c6w50ykxyqun">Message Preview:</p>
                  <p className="text-gray-700 leading-relaxed" data-id="element-402" data-mp="3c8z40842nubi">
                    "Hi {getRecipientFirstName(messageModal.item)}, I noticed
                    your recent assessment activity and wanted to reach out to
                    discuss your progress. Let's schedule a time to connect."
                  </p>
                </div>
              </div>

              {/* Footer */}
              <div className="flex gap-3 p-6 border-t border-gray-100" data-id="element-403" data-mp="11h7e6kt1y9ch">
                <button onClick={() => setMessageModal({
              isOpen: false,
              item: null
            })} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-404" data-mp="wfi1l0q6lnma">
                  Cancel
                </button>
                <button onClick={() => setMessageModal({
              isOpen: false,
              item: null
            })} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium" data-id="element-405" data-mp="1ieeao0xh155p">
                  <Send size={18} data-id="element-406" data-mp="zixppbslv5ld" />
                  Send
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Meeting Modal */}
      <AnimatePresence data-id="element-407" data-mp="6z8wo0rw3k6s">
        {meetingModal.isOpen && meetingModal.item && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setMeetingModal({
        isOpen: false,
        item: null
      })} data-id="element-408" data-mp="3vmf8q4sfa14k">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full" onClick={e => e.stopPropagation()} data-id="element-409" data-mp="37xcl8gb3xe25">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-410" data-mp="go7jeisky1l7">
                <div className="flex items-center gap-3" data-id="element-411" data-mp="ln29m5svmsfc">
                  <div className="w-12 h-12 rounded-lg bg-[#30718D] flex items-center justify-center" data-id="element-412" data-mp="6qujkousews5">
                    <Video size={24} className="text-white" data-id="element-413" data-mp="bpnv4bqikdpo" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-414" data-mp="3u4oshnqsg1yl">
                    Schedule Meeting
                  </h2>
                </div>
                <button onClick={() => setMeetingModal({
              isOpen: false,
              item: null
            })} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-415" data-mp="2sdl0tpfmumc">
                  <X size={20} className="text-gray-500" data-id="element-416" data-mp="3b8gik6mtz2wy" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-417" data-mp="2wiltkog1flub">
                <p className="text-gray-600 mb-1" data-id="element-418" data-mp="2wjx5jbjmzzwi">Schedule a meeting with</p>
                <p className="text-lg font-bold text-gray-900 mb-6" data-id="element-419" data-mp="2rlc79hny3qap">
                  {getRecipientName(meetingModal.item)}
                </p>

                <div className="space-y-4" data-id="element-420" data-mp="35hpelxyrmbbg">
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-421" data-mp="30jxmb2u7kn6q">
                    <p className="text-sm text-gray-500 mb-2" data-id="element-422" data-mp="3fhpxjisq2pf4">Meeting Topic:</p>
                    <p className="text-gray-700 font-medium" data-id="element-423" data-mp="3aj6fvul5vzsk">
                      {meetingModal.item.insight}
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-424" data-mp="3oa1m0z4a02sg">
                    <div data-id="element-425" data-mp="3k8pwetlejhk9">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-426" data-mp="3ka9gkva6icrb">
                        Date
                      </label>
                      <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#30718D] focus:border-transparent" defaultValue={new Date().toISOString().split('T')[0]} data-id="element-427" data-mp="3t9o4po2vib8n" />
                    </div>
                    <div data-id="element-428" data-mp="jk4tx1ugtgkd">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-429" data-mp="jkej4n7orjp0">
                        Time
                      </label>
                      <input type="time" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#30718D] focus:border-transparent" defaultValue="10:00" data-id="element-430" data-mp="3n1mwouvdrxdx" />
                    </div>
                  </div>

                  <div data-id="element-431" data-mp="3rzy6j5loe7w5">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-432" data-mp="3rzoivoo3sctm">
                      Duration
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-433" data-mp="2zctzkv30vjhq">
                      <option data-id="element-434" data-mp="1esyl3ane26h4">15 minutes</option>
                      <option selected data-id="element-435" data-mp="1jlhzuaxtb7ni">30 minutes</option>
                      <option data-id="element-436" data-mp="1jn2tlycaymkb">45 minutes</option>
                      <option data-id="element-437" data-mp="14wv9zfak6xi1">1 hour</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="flex gap-3 p-6 border-t border-gray-100" data-id="element-438" data-mp="19su7bsdv7pul">
                <button onClick={() => setMeetingModal({
              isOpen: false,
              item: null
            })} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-439" data-mp="1xlkcnir9javw">
                  Cancel
                </button>
                <button onClick={() => setMeetingModal({
              isOpen: false,
              item: null
            })} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium" data-id="element-440" data-mp="d7ac7ane9n16">
                  <Calendar size={18} data-id="element-441" data-mp="2a10ime69z8q8" />
                  Schedule
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Kudos Modal */}
      <AnimatePresence data-id="element-442" data-mp="1w3lst8c40yxq">
        {kudosModal.isOpen && kudosModal.item && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setKudosModal({
        isOpen: false,
        item: null
      })} data-id="element-443" data-mp="1w5or0fnf1ydj">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-xl shadow-2xl max-w-lg w-full" onClick={e => e.stopPropagation()} data-id="element-444" data-mp="3ozobbsrpts4e">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-445" data-mp="3f29uvt5sl3c3">
                <div className="flex items-center gap-3" data-id="element-446" data-mp="3k1d1vj5c1jmp">
                  <div className="w-12 h-12 rounded-lg bg-[#007558] flex items-center justify-center" data-id="element-447" data-mp="3k2xwt9vk74l3">
                    <ThumbsUp size={24} className="text-white" data-id="element-448" data-mp="ubj4lak5ut15" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-449" data-mp="z9ue1k6jn1iu">
                    Give Kudos
                  </h2>
                </div>
                <button onClick={() => setKudosModal({
              isOpen: false,
              item: null
            })} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-450" data-mp="289x7ekeus197">
                  <X size={20} className="text-gray-500" data-id="element-451" data-mp="2r6yecarywbfs" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-452" data-mp="2m8n2xvm0xsvg">
                <p className="text-gray-600 mb-1" data-id="element-453" data-mp="2m7lk34yro236">Send kudos to celebrate</p>
                <p className="text-lg font-bold text-gray-900 mb-6" data-id="element-454" data-mp="2zxyrn67qxerz">
                  {getRecipientName(kudosModal.item)}
                </p>

                <div className="bg-[#007558]/5 rounded-lg p-4 border border-[#007558]/20 mb-4" data-id="element-455" data-mp="39xfttdnshaj7">
                  <div className="flex items-center gap-2 mb-2" data-id="element-456" data-mp="39v3hph4ppue2">
                    <Star size={18} className="text-[#007558]" data-id="element-457" data-mp="34zwiomme1dvh" />
                    <p className="text-sm font-medium text-[#007558]" data-id="element-458" data-mp="3ojvbwgb2aovi">
                      Achievement:
                    </p>
                  </div>
                  <p className="text-gray-700" data-id="element-459" data-mp="3th58cfwvc0su">{kudosModal.item.insight}</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-460" data-mp="3eo1p843mpf00">
                  <p className="text-sm text-gray-500 mb-2" data-id="element-461" data-mp="3jjh511l75kz2">Kudos Message:</p>
                  <p className="text-gray-700 leading-relaxed" data-id="element-462" data-mp="35slyvx231hz6">
                    "Congratulations {getRecipientFirstName(kudosModal.item)}!
                    🎉 Your hard work and dedication have really paid off. Keep
                    up the amazing work!"
                  </p>
                </div>

                <div className="mt-4" data-id="element-463" data-mp="30vc0vt0mnxzq">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-464" data-mp="30s7visbfew7h">
                    Add a personal note (optional)
                  </label>
                  <textarea className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#007558] focus:border-transparent resize-none" rows={3} placeholder="Add your personal message..." data-id="element-465" data-mp="2qvuzvowbm8a3" />
                </div>
              </div>

              {/* Footer */}
              <div className="flex gap-3 p-6 border-t border-gray-100" data-id="element-466" data-mp="ip9lp9rt9cs1">
                <button onClick={() => setKudosModal({
              isOpen: false,
              item: null
            })} className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-467" data-mp="imwxwfzdg872">
                  Cancel
                </button>
                <button onClick={() => setKudosModal({
              isOpen: false,
              item: null
            })} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium" data-id="element-468" data-mp="3r4b9qmnud6n1">
                  <ThumbsUp size={18} data-id="element-469" data-mp="2blvdynmwxo1n" />
                  Send Kudos
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Skill Filter Indicator */}
      {selectedSkill !== 'All Skills Combined'}

      {/* Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-6" data-id="element-470" data-mp="2qa00k2p36jpp">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-471" data-mp="2qcccnz85xzuu">
          <div className="flex items-center justify-between mb-3" data-id="element-472" data-mp="14wn41f9ki8mo">
            <div className="w-12 h-12 rounded-lg bg-[#DB3725]/10 flex items-center justify-center" data-id="element-473" data-mp="14yzw4l91hzdg">
              <AlertTriangle size={24} className="text-[#DB3725]" data-id="element-474" data-mp="36scja86yjjg2" />
            </div>
            <span className="text-3xl font-bold text-[#DB3725]" data-id="element-475" data-mp="32r112nqey0hw">
              {urgentCount}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-476" data-mp="3blfh4sirpf22">
            Urgent Actions
          </div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-477" data-mp="2nvl0s0z8p8d2">
            Require immediate attention
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-478" data-mp="2jvax4uyx6u1d">
          <div className="flex items-center justify-between mb-3" data-id="element-479" data-mp="d1yq0zcy7v9y">
            <div className="w-12 h-12 rounded-lg bg-yellow-100 flex items-center justify-center" data-id="element-480" data-mp="83nfsniqrir7">
              <Clock size={24} className="text-yellow-600" data-id="element-481" data-mp="1q1acd28h4out" />
            </div>
            <span className="text-3xl font-bold text-yellow-600" data-id="element-482" data-mp="1v1y11h98ctlv">
              {attentionCount}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-483" data-mp="1h2yo36v2y35j">
            Needs Attention
          </div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-484" data-mp="1m1jhambwzmkh">Monitor and support</div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-485" data-mp="29quiu6139kzo">
          <div className="flex items-center justify-between mb-3" data-id="element-486" data-mp="24xht1skob85c">
            <div className="w-12 h-12 rounded-lg bg-[#007558]/10 flex items-center justify-center" data-id="element-487" data-mp="2soexyle1x573">
              <Star size={24} className="text-[#007558]" data-id="element-488" data-mp="2xgotqi1ukzha" />
            </div>
            <span className="text-3xl font-bold text-[#007558]" data-id="element-489" data-mp="3bbhzq44z0ve">
              {celebrateCount}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-490" data-mp="881y2dfxxwgt">
            Celebrate Success
          </div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-491" data-mp="d14rmlkpx5x0">
            Recognize achievements
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-492" data-mp="3gh1su50wj3j7">
          <div className="flex items-center justify-between mb-3" data-id="element-493" data-mp="3uhcmtgxicy8l">
            <div className="w-12 h-12 rounded-lg bg-[#30718D]/10 flex items-center justify-center" data-id="element-494" data-mp="3uego3qdu65j3">
              <CheckCircle size={24} className="text-[#30718D]" data-id="element-495" data-mp="14tvdc24rzc80" />
            </div>
            <span className="text-3xl font-bold text-[#30718D]" data-id="element-496" data-mp="19souq5n6nndg">
              {skillFilteredItems.length}
            </span>
          </div>
          <div className="text-sm font-medium text-gray-900" data-id="element-497" data-mp="1euxsdrp8os6h">Total Actions</div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-498" data-mp="1a4pq9v1w83t7">
            {selectedSkill === 'All Skills Combined' ? 'All recommended items' : `For ${selectedSkill}`}
          </div>
        </motion.div>
      </div>

      {/* Filter Bar */}
      <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 mb-6" data-id="element-499" data-mp="115m76r2q7oep">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-4" data-id="element-500" data-mp="w46np3g75pyf">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2" data-id="element-501" data-mp="r6dgc735qpwk">
            <div className="flex items-center gap-2" data-id="element-502" data-mp="n5l6bbmgogz8">
              <Filter size={18} className="text-gray-600" data-id="element-503" data-mp="2ljwcpdlgc2ga" />
              <span className="text-sm font-medium text-gray-700" data-id="element-504" data-mp="2lj3bst96c762">
                Filter by:
              </span>
            </div>
            <div className="flex items-center gap-2 flex-wrap" data-id="element-505" data-mp="evm5zpsmoqmj">
              <button onClick={() => setActiveFilter('all')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'all' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-506" data-mp="eu2mlqbodzgj">
                All ({skillFilteredItems.length})
              </button>
              <button onClick={() => setActiveFilter('urgent')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'urgent' ? 'bg-[#DB3725] text-white' : 'bg-[#DB3725]/10 text-[#DB3725] hover:bg-[#DB3725]/20'}`} data-id="element-507" data-mp="xllo1sq1x5gg">
                Urgent ({urgentCount})
              </button>
              <button onClick={() => setActiveFilter('attention')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'attention' ? 'bg-yellow-600 text-white' : 'bg-yellow-50 text-yellow-700 hover:bg-yellow-100'}`} data-id="element-508" data-mp="tmcxewqb5np4">
                Needs Attention ({attentionCount})
              </button>
              <button onClick={() => setActiveFilter('celebrate')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${activeFilter === 'celebrate' ? 'bg-[#007558] text-white' : 'bg-[#007558]/10 text-[#007558] hover:bg-[#007558]/20'}`} data-id="element-509" data-mp="31rvl351eqirs">
                Celebrate ({celebrateCount})
              </button>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-510" data-mp="2i5z66uuofyz0">
            <span className="text-sm font-medium text-gray-700" data-id="element-511" data-mp="2wtbxl0760yxb">View:</span>
            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1 flex-wrap" data-id="element-512" data-mp="2s2ltdqah7247">
              <button onClick={() => setViewType('all')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${viewType === 'all' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-513" data-mp="24cri3d5t1lm2">
                All
              </button>
              <button onClick={() => setViewType('individual')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${viewType === 'individual' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-514" data-mp="17kuqwizlzala">
                Individual ({individualCount})
              </button>
              <button onClick={() => setViewType('macro')} className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${viewType === 'macro' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-515" data-mp="1levhgpgeprak">
                System-Wide ({macroCount})
              </button>
            </div>
          </div>
        </div>
        <div className="text-sm text-gray-600" data-id="element-516" data-mp="yqsyu5yzv7j">
          Showing {filteredItems.length} of {skillFilteredItems.length} items
          {selectedSkill !== 'All Skills Combined' && ` (filtered by ${selectedSkill})`}
        </div>
      </div>

      {/* Action Items List */}
      <div className="space-y-4" data-id="element-517" data-mp="3osw5qe54stud">
        <AnimatePresence mode="popLayout" data-id="element-518" data-mp="3orusc30n7v9h">
          {filteredItems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200" data-id="element-519" data-mp="3jsi7tox8v0a2" data-mpi={index}>
              {/* Header Row - Stack on mobile */}
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-1 gap-2" data-id="element-520" data-mp="2s46p0r58q79z">
                <div className="flex items-center gap-4" data-id="element-521" data-mp="2n2r18rbohmnw">
                  {/* Icon */}
                  <div className={`flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center ${item.priority === 'high' ? 'bg-[#DB3725]/10 border-2 border-[#DB3725]' : item.priority === 'medium' ? 'bg-[#F59E0B]/10 border-2 border-[#F59E0B]' : 'bg-[#007558]/10 border-2 border-[#007558]'}`} data-id="element-522" data-mp="2omsm0gtivc5k">
                    {item.priority === 'high' ? <AlertTriangle size={20} className="text-[#DB3725] sm:w-6 sm:h-6" data-id="element-523" data-mp="25tf1l5nfqo47" /> : item.priority === 'medium' ? <Clock size={20} className="text-[#F59E0B] sm:w-6 sm:h-6" data-id="element-524" data-mp="1vuqu30t2trer" /> : <Star size={20} className="text-[#007558] sm:w-6 sm:h-6" data-id="element-525" data-mp="1mwnk91rgej2s" />}
                  </div>

                  {/* Name and Badge */}
                  <div data-id="element-526" data-mp="18b9myvb015le">
                    <div className="flex items-center gap-2 sm:gap-3 flex-wrap" data-id="element-527" data-mp="13avejc5hjtmu">
                      <h4 className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-528" data-mp="1ha4wohd94xtg">
                        {item.learner ? item.learner.name : 'System Alert'}
                      </h4>
                      <span className={`px-2 sm:px-3 py-1 rounded text-xs font-semibold ${item.priority === 'high' ? 'bg-[#DB3725] text-white' : item.priority === 'medium' ? 'bg-white text-gray-900 border border-gray-900' : 'bg-white text-gray-900 border border-gray-900'}`} data-id="element-529" data-mp="1davzt3mx0jto">
                        {item.priority === 'high' ? 'Urgent' : item.priority === 'medium' ? 'Attention' : 'Celebrate'}
                      </span>
                    </div>
                    {item.learner && <p className="text-sm text-gray-500 mt-0.5 hidden sm:block" data-id="element-530" data-mp="3cb3hqdh2s1tb">
                        {item.learner.email}
                      </p>}
                    {item.type === 'macro' && <p className="text-sm text-gray-500 mt-0.5" data-id="element-531" data-mp="3ldmgomhqpuaa">
                        {item.affectedLearners} learners affected
                      </p>}
                  </div>
                </div>

                {/* Module and Time - Below name on mobile */}
                <div className="text-left sm:text-right ml-14 sm:ml-0" data-id="element-532" data-mp="2xns5e9d2kds5">
                  <p className="font-semibold text-gray-900 text-sm sm:text-base" data-id="element-533" data-mp="32m3dofnpug89">
                    {item.module}
                  </p>
                  <p className="text-xs sm:text-sm text-gray-500" data-id="element-534" data-mp="37ed2fsd3ha8y">
                    {item.lastActivity}
                  </p>
                </div>
              </div>

              {/* Insight */}
              <div className="flex items-start gap-2 mt-4 mb-2" data-id="element-535" data-mp="2euy24cot6a3r">
                <Zap size={18} className="text-gray-700 mt-0.5 flex-shrink-0" data-id="element-536" data-mp="27c6utwpnbjuj" />
                <p className="font-semibold text-gray-900" data-id="element-537" data-mp="22dn99xeysa2p">{item.insight}</p>
              </div>

              {/* Details */}
              <p className="text-sm text-gray-600 ml-6 mb-5 leading-relaxed" data-id="element-538" data-mp="1xdr3ptqmcal1">
                {item.details}
              </p>

              {/* Suggested Actions */}
              <div className="mb-5" data-id="element-539" data-mp="1oevx4gjnwyh7">
                <p className="text-sm font-semibold text-gray-700 mb-3" data-id="element-540" data-mp="1of5ly0sz0zlb">
                  Suggested Actions
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-541" data-mp="1jlkqogirijpt">
                  {item.suggestedActions.map((action, idx) => <span key={idx} className="px-4 py-2 bg-gray-100 text-gray-800 rounded text-sm font-medium border border-gray-200" data-id="element-542" data-mp="19prdcux7ym6z" data-mpi={idx}>
                      {action}
                    </span>)}
                </div>
              </div>

              {/* Action Buttons - Wrap on mobile */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 pt-5 border-t border-gray-200" data-id="element-543" data-mp="1f8p75ilo0t6k">
                <div className="flex flex-wrap items-center gap-2 sm:gap-3" data-id="element-544" data-mp="16a3ozok3vg6b">
                  <button onClick={() => setMessageModal({
                isOpen: true,
                item
              })} className="flex items-center gap-2 px-3 sm:px-5 py-2 sm:py-2.5 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-all text-sm font-medium" data-id="element-545" data-mp="16c7vme9e2taa">
                    <Mail size={16} data-id="element-546" data-mp="1p6mwyaj6ay1a" />
                    <span className="hidden sm:inline" data-id="element-547" data-mp="1kaoaishenq3i">Send Message</span>
                  </button>
                  <button onClick={() => setMeetingModal({
                isOpen: true,
                item
              })} className="flex items-center gap-2 px-3 sm:px-5 py-2 sm:py-2.5 border border-gray-300 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-all text-sm font-medium" data-id="element-548" data-mp="2hpir16r68y8a">
                    <Video size={16} data-id="element-549" data-mp="2u6be9ysgr7or" />
                    <span className="hidden sm:inline" data-id="element-550" data-mp="2y9hmvd31taye">Schedule Meeting</span>
                  </button>
                  {item.priority === 'positive' && <button onClick={() => setKudosModal({
                isOpen: true,
                item
              })} className="flex items-center gap-2 px-3 sm:px-5 py-2 sm:py-2.5 border border-[#007558] bg-[#007558]/10 text-[#007558] rounded-lg hover:bg-[#007558]/20 transition-all text-sm font-medium" data-id="element-551" data-mp="3381b5k546ytx">
                      <ThumbsUp size={16} data-id="element-552" data-mp="3qxdkck0fz6w8" />
                      <span className="hidden sm:inline" data-id="element-553" data-mp="3qyev0ndjprdf">Send Kudos</span>
                    </button>}
                </div>
                <button className="text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors self-start sm:self-auto" data-id="element-554" data-mp="1muka3jxmzkmx">
                  Dismiss
                </button>
              </div>
            </motion.div>)}
        </AnimatePresence>
      </div>
    </div>;
}
function AggregateView({
  totalLearners,
  totalAssessments,
  overallAvgScore,
  overallMastery,
  moduleData,
  scoreDistribution,
  attemptTrends,
  COLORS,
  selectedSkill,
  setSelectedSkill,
  isSkillDropdownOpen,
  setIsSkillDropdownOpen,
  skillDropdownRef,
  skillOptions,
  selectedLearner,
  setSelectedLearner,
  selectedLearnerData,
  isLearnerDropdownOpen,
  setIsLearnerDropdownOpen,
  learnerDropdownRef
}) {
  const [selectedInsightSkill, setSelectedInsightSkill] = useState<string>('All Skills Combined');
  const [isInsightSkillDropdownOpen, setIsInsightSkillDropdownOpen] = useState(false);
  const insightSkillDropdownRef = useRef<HTMLDivElement>(null);
  const [selectedLeaderboardSkill, setSelectedLeaderboardSkill] = useState<string>('All Skills Combined');
  const [isLeaderboardSkillDropdownOpen, setIsLeaderboardSkillDropdownOpen] = useState(false);
  const leaderboardSkillDropdownRef = useRef<HTMLDivElement>(null);
  const [selectedLeaderboardMetric, setSelectedLeaderboardMetric] = useState<string>('Average Score');
  const [isLeaderboardMetricDropdownOpen, setIsLeaderboardMetricDropdownOpen] = useState(false);
  const leaderboardMetricDropdownRef = useRef<HTMLDivElement>(null);
  const [performanceLearnerFilter, setPerformanceLearnerFilter] = useState<string>('All Learners');
  const [performanceLearnerSearch, setPerformanceLearnerSearch] = useState<string>('');
  const [isPerformanceLearnerDropdownOpen, setIsPerformanceLearnerDropdownOpen] = useState(false);
  const performanceLearnerDropdownRef = useRef<HTMLDivElement>(null);
  const [performanceSortKey, setPerformanceSortKey] = useState<PerformanceTableSortKey>('confidentIncorrect');
  const [performanceSortDir, setPerformanceSortDir] = useState<'asc' | 'desc'>('desc');
  const [performancePage, setPerformancePage] = useState(1);
  const [isPerformancePageDropdownOpen, setIsPerformancePageDropdownOpen] = useState(false);
  const performancePageDropdownRef = useRef<HTMLDivElement>(null);
  const performancePerPage = 10;
  const handlePerformanceSort = (key: PerformanceTableSortKey) => {
    if (performanceSortKey === key) {
      setPerformanceSortDir(performanceSortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setPerformanceSortKey(key);
      setPerformanceSortDir('asc');
    }
    setPerformancePage(1);
  };
  const [selectedChartType, setSelectedChartType] = useState<string>('Score Distribution');
  const [isChartTypeDropdownOpen, setIsChartTypeDropdownOpen] = useState(false);
  const chartTypeDropdownRef = useRef<HTMLDivElement>(null);
  const chartTypeOptions = ['Score Distribution', 'Performance by Attempt', 'Answer Confidence Breakdown'];
  const chartAreaRef = useRef<HTMLDivElement>(null);
  const handleDownloadChart = () => {
    if (!chartAreaRef.current) return;
    const svgElement = chartAreaRef.current.querySelector('svg');
    if (!svgElement) return;
    const svgClone = svgElement.cloneNode(true) as SVGElement;
    // Ensure the SVG has explicit dimensions
    const bbox = svgElement.getBoundingClientRect();
    svgClone.setAttribute('width', String(bbox.width));
    svgClone.setAttribute('height', String(bbox.height));
    svgClone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgClone);
    const svgBlob = new Blob([svgString], {
      type: 'image/svg+xml;charset=utf-8'
    });
    const url = URL.createObjectURL(svgBlob);
    const canvas = document.createElement('canvas');
    const scale = 2; // retina quality
    canvas.width = bbox.width * scale;
    canvas.height = bbox.height * scale;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const img = new Image();
    img.onload = () => {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);
      const pngUrl = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = `${selectedChartType.replace(/\s+/g, '_')}_chart.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
    img.src = url;
  };
  // Local learner state for Data Explorer (doesn't switch to IndividualView)
  const [selectedChartLearner, setSelectedChartLearner] = useState<number | null>(null);
  const [isChartLearnerDropdownOpen, setIsChartLearnerDropdownOpen] = useState(false);
  const chartLearnerDropdownRef = useRef<HTMLDivElement>(null);
  const selectedChartLearnerData = selectedChartLearner ? mockLearners.find(l => l.id === selectedChartLearner) : null;
  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (insightSkillDropdownRef.current && !insightSkillDropdownRef.current.contains(event.target as Node)) {
        setIsInsightSkillDropdownOpen(false);
      }
      if (leaderboardSkillDropdownRef.current && !leaderboardSkillDropdownRef.current.contains(event.target as Node)) {
        setIsLeaderboardSkillDropdownOpen(false);
      }
      if (leaderboardMetricDropdownRef.current && !leaderboardMetricDropdownRef.current.contains(event.target as Node)) {
        setIsLeaderboardMetricDropdownOpen(false);
      }
      if (chartTypeDropdownRef.current && !chartTypeDropdownRef.current.contains(event.target as Node)) {
        setIsChartTypeDropdownOpen(false);
      }
      if (chartLearnerDropdownRef.current && !chartLearnerDropdownRef.current.contains(event.target as Node)) {
        setIsChartLearnerDropdownOpen(false);
      }
      if (performanceLearnerDropdownRef.current && !performanceLearnerDropdownRef.current.contains(event.target as Node)) {
        setIsPerformanceLearnerDropdownOpen(false);
      }
      if (performancePageDropdownRef.current && !performancePageDropdownRef.current.contains(event.target as Node)) {
        setIsPerformancePageDropdownOpen(false);
      }
    };
    if (isInsightSkillDropdownOpen || isLeaderboardSkillDropdownOpen || isLeaderboardMetricDropdownOpen || isChartTypeDropdownOpen || isChartLearnerDropdownOpen || isPerformanceLearnerDropdownOpen || isPerformancePageDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isInsightSkillDropdownOpen, isLeaderboardSkillDropdownOpen, isLeaderboardMetricDropdownOpen, isChartTypeDropdownOpen, isChartLearnerDropdownOpen, isPerformanceLearnerDropdownOpen, isPerformancePageDropdownOpen]);
  // Filter module data based on selected skill
  const filteredModuleData = selectedSkill === 'All Skills Combined' ? moduleData : moduleData.filter(m => m.module === selectedSkill);
  // Filter module data for insight cards based on local insight skill selector
  const insightFilteredModuleData = selectedInsightSkill === 'All Skills Combined' ? moduleData : moduleData.filter(m => m.module === selectedInsightSkill);
  // Calculate insight-filtered metrics
  const insightFilteredAvgScore = insightFilteredModuleData.length > 0 ? Math.round(insightFilteredModuleData.reduce((sum, m) => sum + m.avgScore, 0) / insightFilteredModuleData.length) : 0;
  const insightFilteredAttempts = insightFilteredModuleData.reduce((sum, m) => sum + m.attempts, 0);
  // Calculate filtered metrics
  const filteredAvgScore = filteredModuleData.length > 0 ? Math.round(filteredModuleData.reduce((sum, m) => sum + m.avgScore, 0) / filteredModuleData.length) : 0;
  const filteredMastery = filteredModuleData.length > 0 ? Math.round(filteredModuleData.reduce((sum, m) => sum + m.mastery, 0) / filteredModuleData.length) : 0;
  const filteredAttempts = filteredModuleData.reduce((sum, m) => sum + m.attempts, 0);
  // Filter score distribution based on skill (simulated - in real app this would come from backend)
  const filteredScoreDistribution = selectedSkill === 'All Skills Combined' ? scoreDistribution : scoreDistribution.map(item => ({
    ...item,
    count: Math.round(item.count * (filteredModuleData.length / moduleData.length))
  }));
  // Skill Performance header controls
  const [skillPerfTimeRange, setSkillPerfTimeRange] = useState<30 | 60 | 90>(30);
  const [skillPerfLastUpdated, setSkillPerfLastUpdated] = useState<Date>(new Date());
  const [isSkillPerfRefreshing, setIsSkillPerfRefreshing] = useState(false);
  const [isTimeRangeDropdownOpen, setIsTimeRangeDropdownOpen] = useState(false);
  const timeRangeDropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (timeRangeDropdownRef.current && !timeRangeDropdownRef.current.contains(event.target as Node)) {
        setIsTimeRangeDropdownOpen(false);
      }
    };
    if (isTimeRangeDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isTimeRangeDropdownOpen]);
  const handleSkillPerfRefresh = () => {
    setIsSkillPerfRefreshing(true);
    setTimeout(() => {
      setSkillPerfLastUpdated(new Date());
      setIsSkillPerfRefreshing(false);
    }, 800);
  };
  const formatRelativeTime = (date: Date) => {
    const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
    if (diffSec < 60) return 'Just now';
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} minute${diffMin === 1 ? '' : 's'} ago`;
    const diffHr = Math.floor(diffMin / 60);
    return `${diffHr} hour${diffHr === 1 ? '' : 's'} ago`;
  };
  return <>
      {/* Aggregate Data Across All Assessments */}

      {/* Assessment Insights */}
      <div data-phoebe-tour="analytics-summary" className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-visible mb-6" data-id="element-555" data-mp="ci8qlpmk7tc5">
        {/* Assessment Insights Header */}
        <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4" data-id="element-556" data-mp="21ybcl7a8mpwt">
          <div data-id="element-557" data-mp="1x000sr0du5by">
            <div className="flex items-center gap-2" data-id="element-558" data-mp="1x1kuyfisbm9a">
              <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-559" data-mp="1s7q3gpwxu2zn">
                <BarChart3 size={22} className="text-[#30718D]" data-id="element-560" data-mp="1nagetchdhvcv" />
                Skill Performance
              </h4>
              <AIInsightPopover align="left" headline="CSS Fundamentals is a priority support opportunity" insightBeforeMetric="CSS Fundamentals has a" highlightedMetric="22% misinformation rate" insightAfterMetric=", above the other core modules." explanation="Clearer practice around Flexbox, Grid, and positioning can improve readiness before the next assessment." insightId={8} data-id="element-561" data-mp="1j8uwvcpzeqvt" />
            </div>
            <p className="text-sm text-gray-500 ml-[26px]" data-id="element-562" data-mp="2ymr0kyxp8r7t">
              {selectedInsightSkill === 'All Skills Combined' ? 'Detailed metrics for all skills' : `Detailed metrics for ${selectedInsightSkill}`}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2" data-id="element-563" data-mp="2wqk9iv0qiivg">
            {/* Skill dropdown */}
            <div className="relative" ref={insightSkillDropdownRef} data-id="element-564" data-mp="31p586q0c8uhs">
              <button onClick={() => setIsInsightSkillDropdownOpen(!isInsightSkillDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-565" data-mp="2nyib12a87cnt">
                <Target size={16} className="text-[#30718D]" data-id="element-566" data-mp="2ixm6qnlypohv" />
                <span className="flex-1 text-left" data-id="element-567" data-mp="250pkkzgsgv7b">{selectedInsightSkill}</span>
                <ChevronDown size={16} className={`transition-transform text-gray-500 ${isInsightSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-568" data-mp="290pwodgf0ub7" />
              </button>

              {isInsightSkillDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-569" data-mp="1ze5iqg1xi21w">
                  {skillOptions.map(skill => <button key={skill} onClick={() => {
                setSelectedInsightSkill(skill);
                setIsInsightSkillDropdownOpen(false);
              }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedInsightSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-570" data-mp="1uhf3fuxy7ahj">
                      {skill}
                    </button>)}
                </div>}
            </div>
            {/* Time range dropdown */}
            <div className="relative" ref={timeRangeDropdownRef} data-id="element-571" data-mp="1ks6ars988p3v">
              <button onClick={() => setIsTimeRangeDropdownOpen(!isTimeRangeDropdownOpen)} className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-semibold text-gray-900 min-w-[130px]" data-id="element-572" data-mp="1osyn4udeba4d">
                <Calendar size={14} className="text-[#30718D]" data-id="element-573" data-mp="23j5uadxyd6pr" />
                <span className="flex-1 text-left" data-id="element-574" data-mp="28el9pablzaoa">
                  Last {skillPerfTimeRange} days
                </span>
                <ChevronDown size={14} className={`transition-transform text-gray-500 ${isTimeRangeDropdownOpen ? 'rotate-180' : ''}`} data-id="element-575" data-mp="2cfeu3tpue7cf" />
              </button>
              {isTimeRangeDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-576" data-mp="n3mgfj0xbi3w">
                  {[30, 60, 90].map(range => <button key={range} onClick={() => {
                setSkillPerfTimeRange(range as 30 | 60 | 90);
                setIsTimeRangeDropdownOpen(false);
              }} className={`w-full px-4 py-2.5 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${skillPerfTimeRange === range ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-577" data-mp="artsaphzui8g">
                      Last {range} days
                    </button>)}
                </div>}
            </div>
            {/* Last updated + Refresh button */}
          </div>
        </div>

        {/* Metrics Grid */}
        <div className="p-3 sm:p-6" data-id="element-578" data-mp="397mq9kma5hmd">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-579" data-mp="3584d5b0paau3">
            {/* Row 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-580" data-mp="186ykz66dwqkx">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-581" data-mp="1rvh2r2p291pl">
                Learners Attempted
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-582" data-mp="1vz5bhopfi3cf">
                86
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-583" data-mp="1n4h67yjuslnm">
                Total number of learners who attempted the assessment for skill
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-584" data-mp="2fl1p7vkfah3m">
                <span className="text-[10px] sm:text-xs" data-id="element-585" data-mp="2ozlk3v3pms0v">▲</span>
                <span data-id="element-586" data-mp="2oy0t2fgltr7r">
                  12%<span className="hidden sm:inline" data-id="element-587" data-mp="2kyrumxamd55v"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.15
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-588" data-mp="2yoloju0zefmg">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-589" data-mp="2fzp0w903ald7">
                Learners Passed
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-590" data-mp="2b2oufwzbvglk">
                85
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-591" data-mp="3mg0tzvo21d1x">
                Number of learners who successfully passed the skill
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-592" data-mp="zvq53o90qmz6">
                <span className="text-[10px] sm:text-xs" data-id="element-593" data-mp="l73gevxi4iva">▲</span>
                <span data-id="element-594" data-mp="l4r3ix6loyp3">
                  14%<span className="hidden sm:inline" data-id="element-595" data-mp="q5wtwocsg9vg"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-596" data-mp="c5cdfyuciq54">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-597" data-mp="1wlgzlnhb8a4z">
                Completion Rate
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-598" data-mp="21izb9lmpp3go">
                98.33%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-599" data-mp="3h4jhv0vm2g1p">
                Percentage of learners who passed the assessment
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-600" data-mp="3r27ddt11jrkx">
                <span className="text-[10px] sm:text-xs" data-id="element-601" data-mp="8o7u6ud2x5xy">▲</span>
                <span data-id="element-602" data-mp="8menxg6donqh">
                  3%<span className="hidden sm:inline" data-id="element-603" data-mp="4mmn5pn87lvo"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.25
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-604" data-mp="ilcjh3281hiz">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-605" data-mp="jc2m2gji4jud">
                Avg. Number of Attempts
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-606" data-mp="ocqcp13tiyo2">
                3.78
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-607" data-mp="xb27lfbpwimb">
                Average number of attempts per learner to complete the skill
              </div>
              <div className="flex items-center gap-1.5 text-[#DB3725] text-xs sm:text-sm font-medium" data-id="element-608" data-mp="1798bg2h33ytt">
                <span className="text-[10px] sm:text-xs" data-id="element-609" data-mp="1c0gmt41z5u9m">▼</span>
                <span data-id="element-610" data-mp="1c2b6yg5f9icn">
                  8%<span className="hidden sm:inline" data-id="element-611" data-mp="1g1k0bjwjve7o"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-id="element-612" data-mp="1l2g47xgwj0d3">
            {/* Row 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-613" data-mp="1q097oiqtlg9o">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-614" data-mp="1m56nz7pk0ucs">
                Avg. Final Score
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-615" data-mp="2dvb5mylxj3ab">
                92.25%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-616" data-mp="293jealuy8tj4">
                Average final score achieved by all learners
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-617" data-mp="31kngs40thlf9">
                <span className="text-[10px] sm:text-xs" data-id="element-618" data-mp="2wtnj2wjvizbp">▲</span>
                <span data-id="element-619" data-mp="2ws2qhch4dqgh">
                  5%<span className="hidden sm:inline" data-id="element-620" data-mp="2hcffm4klduyh"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.35
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 overflow-visible" data-id="element-621" data-mp="2mc1wqp3jjvck">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-622" data-mp="350f756pq9pe4">
                Avg. First Score
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-623" data-mp="2vbow75cpmr2z">
                64.93%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-624" data-mp="3j0gglak26557">
                Average score achieved on first attempt
              </div>
              <div className="flex items-center gap-1.5 text-[#DB3725] text-xs sm:text-sm font-medium" data-id="element-625" data-mp="1ccza04voukkm">
                <span className="text-[10px] sm:text-xs" data-id="element-626" data-mp="17epiq5d3444a">▼</span>
                <span data-id="element-627" data-mp="17cbo1xmbgtx9">
                  3%<span className="hidden sm:inline" data-id="element-628" data-mp="1m2snxcjazbs1"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-629" data-mp="1h5afdn976ykk">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-630" data-mp="yd81gjnxxwe0">
                Avg. Mastery Rate
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-631" data-mp="2etkhs3cwboc7">
                65.52%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-632" data-mp="2gwmgkt7uotq4">
                Average mastery rate across all attempts
              </div>
              <div className="flex items-center gap-1.5 text-[#007558] text-xs sm:text-sm font-medium" data-id="element-633" data-mp="2qu0x0strxiif">
                <span className="text-[10px] sm:text-xs" data-id="element-634" data-mp="2vt3u9r3iikfu">▲</span>
                <span data-id="element-635" data-mp="2vsc631c8vozl">
                  7%<span className="hidden sm:inline" data-id="element-636" data-mp="1y5d7gl1zs6z2"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.45
          }} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6" data-id="element-637" data-mp="235hnk9yzmzor">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-638" data-mp="1kdf30nj86z98">
                Avg. Misinfo Rate
              </div>
              <div className="text-2xl sm:text-4xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-639" data-mp="1gq2207lp4ys">
                18.18%
              </div>
              <div className="text-xs sm:text-sm text-gray-600 hidden sm:block mb-1 sm:mb-2" data-id="element-640" data-mp="3ona0mvdq215r">
                Average misinformation rate across all attempts
              </div>
              <div className="flex items-center gap-1.5 text-[#DB3725] text-xs sm:text-sm font-medium" data-id="element-641" data-mp="3jqt9rtf518oz">
                <span className="text-[10px] sm:text-xs" data-id="element-642" data-mp="39ynkwsk6n7e0">▼</span>
                <span data-id="element-643" data-mp="39x2nmv6hhacg">
                  4%<span className="hidden sm:inline" data-id="element-644" data-mp="39wsx96hj1168"> vs 30 days ago</span>
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Unified Data Explorer Section */}
      <div data-phoebe-tour="analytics-explorer" className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-visible mb-6" data-id="element-645" data-mp="2vze5hv3swhb3">
        {/* Section Header */}
        <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200 overflow-visible" data-id="element-646" data-mp="2r247hr2cixbn">
          <div className="flex items-center gap-2" data-id="element-647" data-mp="jmgnuxwom69f">
            <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-648" data-mp="np4ztegoztam">
              <TrendingUp size={22} className="text-[#30718D]" data-id="element-649" data-mp="9r6m8ba740w6" />
              Data Explorer
            </h4>
            <AIInsightPopover align="left" headline="First-attempt scores are the clearest improvement lever" insightBeforeMetric="Learners gain roughly" highlightedMetric="13 points" insightAfterMetric=" between their first and final attempts." explanation="Comparing skills side by side shows where earlier practice would reduce retakes the most." insightId={10} data-id="element-650" data-mp="eof9gqa7av4a" />
          </div>
          <p className="text-sm text-gray-500 ml-[26px]" data-id="element-651" data-mp="3d85bczshufhi">
            Visualize and compare performance data across learners and skills
          </p>
        </div>
        {/* Header with Dropdowns */}
        <div className="p-3 sm:p-6 border-b border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-4" data-id="element-652" data-mp="2ylgel5pmmget">
          {/* Chart Type Dropdown */}
          <div className="relative flex-1" ref={chartTypeDropdownRef} data-id="element-653" data-mp="38ibd3olwggt3">
            <button onClick={() => {
            setIsChartTypeDropdownOpen(!isChartTypeDropdownOpen);
            setIsSkillDropdownOpen(false);
            setIsLearnerDropdownOpen(false);
          }} className="flex items-center justify-between px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white w-full text-sm font-medium" data-id="element-654" data-mp="38gi5o73gpsk1">
              <div className="flex items-center gap-2" data-id="element-655" data-mp="3ma9efd9dd8ep">
                <BarChart3 size={18} className="text-[#30718D]" data-id="element-656" data-mp="3mariux66qsxp" />
                <span className="text-left" data-id="element-657" data-mp="512yddmgxx2l">{selectedChartType}</span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${isChartTypeDropdownOpen ? 'rotate-180' : ''}`} data-id="element-658" data-mp="3b2y9mm7stn" />
            </button>

            {isChartTypeDropdownOpen && <div className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-659" data-mp="wiwmnxuw7xto">
                {chartTypeOptions.map(type => <button key={type} onClick={() => {
              setSelectedChartType(type);
              setIsChartTypeDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedChartType === type ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-660" data-mp="ngndbbbd2ahv">
                    {type}
                  </button>)}
              </div>}
          </div>

          {/* Skill Selector Dropdown */}
          <div className="relative flex-1" ref={skillDropdownRef} data-id="element-661" data-mp="3r0i9qerecq4b">
            <button onClick={() => {
            setIsSkillDropdownOpen(!isSkillDropdownOpen);
            setIsChartLearnerDropdownOpen(false);
            setIsChartTypeDropdownOpen(false);
          }} className="flex items-center justify-between px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white w-full text-sm font-medium" data-id="element-662" data-mp="26flatz8uxe9b">
              <div className="flex items-center gap-2" data-id="element-663" data-mp="1nnsh22lyrp0j">
                <Target size={18} className="text-[#30718D]" data-id="element-664" data-mp="1so6nxhbtwswz" />
                <span className="text-left" data-id="element-665" data-mp="1wql9482z04rf">{selectedSkill}</span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${isSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-666" data-mp="1wogyz8eha9ip" />
            </button>

            {isSkillDropdownOpen && <div className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-667" data-mp="190qzdzdy6wbe">
                {skillOptions.map(skill => <button key={skill} onClick={() => {
              setSelectedSkill(skill);
              setIsSkillDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-668" data-mp="2c9jvgkgewcrk">
                    {skill}
                  </button>)}
              </div>}
          </div>

          {/* Learner Dropdown */}
          <div className="relative flex-1" ref={chartLearnerDropdownRef} data-id="element-669" data-mp="1yblx2oihkqxp">
            <button onClick={() => {
            setIsChartLearnerDropdownOpen(!isChartLearnerDropdownOpen);
            setIsSkillDropdownOpen(false);
            setIsChartTypeDropdownOpen(false);
          }} className="flex items-center justify-between px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white w-full text-sm font-medium" data-id="element-670" data-mp="1yehqq0nawtgc">
              <div className="flex items-center gap-2" data-id="element-671" data-mp="37df3qzb6zb20">
                <Users size={18} className="text-[#30718D]" data-id="element-672" data-mp="37eq4srd964pf" />
                <span className="text-left" data-id="element-673" data-mp="3cchxhnlq1uuo">
                  {selectedChartLearnerData ? selectedChartLearnerData.name : 'All Learners'}
                </span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${isChartLearnerDropdownOpen ? 'rotate-180' : ''}`} data-id="element-674" data-mp="8u85d1hsycja" />
            </button>

            {isChartLearnerDropdownOpen && <div className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10 max-h-80 overflow-y-auto" data-id="element-675" data-mp="mv14jzj1tvsq">
                <button onClick={() => {
              setSelectedChartLearner(null);
              setIsChartLearnerDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 text-sm ${selectedChartLearner === null ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-676" data-mp="rn2az4tjcsau">
                  All Learners
                </button>
                {[...mockLearners].sort((a, b) => {
              const lastNameA = a.name.split(' ').slice(-1)[0].toLowerCase();
              const lastNameB = b.name.split(' ').slice(-1)[0].toLowerCase();
              return lastNameA.localeCompare(lastNameB);
            }).map(learner => <button key={learner.id} onClick={() => {
              setSelectedChartLearner(learner.id);
              setIsChartLearnerDropdownOpen(false);
            }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 ${selectedChartLearner === learner.id ? 'bg-[#30718D]/5' : ''}`} data-id="element-677" data-mp="mn9ro560sxo">
                      <div className={`font-medium text-sm ${selectedChartLearner === learner.id ? 'text-[#30718D]' : 'text-gray-900'}`} data-id="element-678" data-mp="rvqh6d6zc2ze">
                        {learner.name}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-679" data-mp="10pbt7orrf654">
                        {learner.email}
                      </div>
                    </button>)}
              </div>}
          </div>

          {/* Download Chart Button */}
          <button onClick={handleDownloadChart} className="px-4 py-2.5 rounded-lg text-sm font-medium transition-all relative flex items-center gap-2 bg-[#DB3725] text-white hover:bg-[#c02f1f] flex-shrink-0" data-id="element-680" data-mp="1flb1azevd6a9">
            <Download size={16} data-id="element-681" data-mp="kvg8efm1d058" />
            <span data-id="element-682" data-mp="zmfcpefu92j0">Download</span>
          </button>
        </div>

        {/* Chart Area */}
        <div className="p-3 sm:p-6" ref={chartAreaRef} data-id="element-683" data-mp="uuxayo5zqxwz">
          {selectedChartType === 'Score Distribution' && <div data-id="element-684" data-mp="18lu4ch7qrj53">
              <h3 className="text-sm sm:text-lg font-semibold mb-4 sm:mb-6" data-id="element-685" data-mp="18lal8x6cuoph">
                Score Distribution
                {selectedChartLearnerData ? ` - ${selectedChartLearnerData.name}` : ' - All Learners'}
                {selectedSkill !== 'All Skills Combined' ? ` - ${selectedSkill}` : ' - All Skills Combined'}
              </h3>
              <ResponsiveContainer width="100%" height={300} data-id="element-686" data-mp="3keik9tnr1og3">
                {(() => {
              // Simulated "other students" distribution for comparison
              const otherStudentsCounts = [3, 7, 12, 18, 10];
              const dataWithOthers = filteredScoreDistribution.map((d, i) => ({
                ...d,
                others: otherStudentsCounts[i] ?? Math.round(d.count * 0.8)
              }));
              return <ComposedChart data={dataWithOthers} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-687" data-mp="1c49nvbj8vsym">
                      <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} data-id="element-688" data-mp="1756jltb39qrp" />
                      <XAxis dataKey="range" axisLine={{
                  stroke: '#d1d5db'
                }} tickLine={false} tick={{
                  fill: '#6b7280',
                  fontSize: 12
                }} dy={10} data-id="element-689" data-mp="31jh5pu0au6ts" />
                      <YAxis axisLine={false} tickLine={false} tick={{
                  fill: '#6b7280',
                  fontSize: 12
                }} data-id="element-690" data-mp="1am9fdscdpudg" />
                      <Tooltip cursor={{
                  fill: 'rgba(0, 0, 0, 0.04)'
                }} contentStyle={{
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  borderRadius: '4px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                  padding: '8px 12px'
                }} data-id="element-691" data-mp="wlosol3cfeeo" />
                      <Bar dataKey="count" name="Learners" fill="rgba(48, 113, 141, 0.5)" stroke="#30718D" strokeWidth={1} radius={[0, 0, 0, 0]} barSize={40} data-id="element-692" data-mp="339yz07s98o7w" />
                      <Line dataKey="others" name="Other Students" type="monotone" stroke="#7CB9E8" strokeWidth={2} dot={{
                  r: 4,
                  fill: '#fff',
                  stroke: '#7CB9E8',
                  strokeWidth: 2
                }} activeDot={{
                  r: 6,
                  fill: '#fff',
                  stroke: '#7CB9E8',
                  strokeWidth: 2
                }} data-id="element-693" data-mp="2fl5zk1cfby8j" />
                    </ComposedChart>;
            })()}
              </ResponsiveContainer>
            </div>}

          {selectedChartType === 'Performance by Attempt' && <div data-id="element-694" data-mp="3i0dzawxdfvh7">
              <h3 className="text-sm sm:text-lg font-semibold mb-4 sm:mb-6" data-id="element-695" data-mp="3i0vtlo0h3zmh">
                Performance by Attempt
                {selectedChartLearnerData ? ` - ${selectedChartLearnerData.name}` : ' - All Learners'}
                {selectedSkill !== 'All Skills Combined' ? ` - ${selectedSkill}` : ' - All Skills Combined'}
              </h3>
              <ResponsiveContainer width="100%" height={300} data-id="element-696" data-mp="16bw724ptnm2r">
                <AreaChart data={attemptTrends} margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-697" data-mp="1b71td4n4z2rd">
                  <defs data-id="element-698" data-mp="2m0kq14mcb0pj">
                    <linearGradient id="colorScore" x1="0" y1="0" x2="0" y2="1" data-id="element-699" data-mp="2lzstnrkx4yy7">
                      <stop offset="5%" stopColor="rgba(48, 113, 141, 0.2)" stopOpacity={1} data-id="element-700" data-mp="2h2au2rssjw2v" />
                      <stop offset="95%" stopColor="rgba(48, 113, 141, 0.0)" stopOpacity={1} data-id="element-701" data-mp="281clrxbbl2eh" />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} data-id="element-702" data-mp="1y4gc3o9oqa8c" />
                  <XAxis dataKey="attempt" axisLine={{
                stroke: '#d1d5db'
              }} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} dy={10} data-id="element-703" data-mp="3sgodnkgihpd3" />
                  <YAxis domain={[0, 100]} axisLine={false} tickLine={false} tick={{
                fill: '#6b7280',
                fontSize: 12
              }} data-id="element-704" data-mp="1lsnqb1e89mg2" />
                  <Tooltip contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '4px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                padding: '8px 12px'
              }} data-id="element-705" data-mp="2eez092nq4zpj" />
                  <Area type="monotone" dataKey="avgScore" stroke="#30718D" strokeWidth={2} fillOpacity={1} fill="url(#colorScore)" dot={{
                r: 4,
                fill: '#fff',
                stroke: '#30718D',
                strokeWidth: 2
              }} activeDot={{
                r: 6,
                fill: '#fff',
                stroke: '#30718D',
                strokeWidth: 2
              }} data-id="element-706" data-mp="ljxz14fq9p91" />
                </AreaChart>
              </ResponsiveContainer>
            </div>}

          {selectedChartType === 'Answer Confidence Breakdown' && <div data-id="element-707" data-mp="3g7l1c2qgv3ta">
              <div className="flex items-center justify-between mb-4 sm:mb-5" data-id="element-708" data-mp="3g71lcrkdmphw">
                <h3 className="text-sm sm:text-lg font-bold text-gray-900" data-id="element-709" data-mp="3b902o7qv4s6y">
                  Answer Confidence Breakdown
                  {selectedChartLearnerData ? ` - ${selectedChartLearnerData.name}` : ' - All Learners'}
                  {selectedSkill !== 'All Skills Combined' ? ` - ${selectedSkill}` : ' - All Skills Combined'}
                </h3>
              </div>
              <div className="space-y-3 sm:space-y-4" data-id="element-710" data-mp="2x95ugvks69jl">
                {filteredModuleData.length > 0 ? filteredModuleData.map((module, index) => <div key={index} className="bg-[#F9FAFB] rounded-lg p-3 sm:p-5 border border-[#E5E7EB]" data-id="element-711" data-mp="32a39izahungv" data-mpi={index}>
                      <div className="flex items-center justify-between mb-4 sm:mb-6" data-id="element-712" data-mp="3b859rcmelc33">
                        <div data-id="element-713" data-mp="1bwuntiqxspic">
                          <h4 className="font-semibold text-sm sm:text-[14px] text-gray-900" data-id="element-714" data-mp="1bxnp4474mmt3">
                            {module.module}
                          </h4>
                        </div>
                        <div className="text-right" data-id="element-715" data-mp="19d7u05lqej59">
                          <div className="text-xl sm:text-[25px] font-bold text-[#30718D] leading-none" data-id="element-716" data-mp="14k4yvt1b31my">
                            {module.avgScore}%
                          </div>
                          <div className="text-[10px] sm:text-xs font-medium text-gray-500 mt-1" data-id="element-717" data-mp="umqqmgpjdj5q">
                            Highest Score
                          </div>
                        </div>
                      </div>

                      {/* Answer Confidence Breakdown */}
                      <div data-id="element-718" data-mp="1ibjerqzx2mps">
                        <h5 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-719" data-mp="1iarw1grf4jgx">
                          Answer Confidence Breakdown
                        </h5>

                        {/* Stacked Bar Visualization */}
                        <div className="mb-7" data-id="element-720" data-mp="6y7iq2aef8e6">
                          {/* SVG Pattern Definitions */}
                          <svg width="0" height="0" className="absolute" data-id="element-721" data-mp="2trgcazzuj3p">
                            <defs data-id="element-722" data-mp="4djbie0pg3g7">
                              <pattern id={`pattern-diagonal-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-723" data-mp="4a560wwqve4j">
                                <rect width="8" height="8" fill="#007558" data-id="element-724" data-mp="3vkm2p5gjm9qf" />
                                <path d="M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4" stroke="rgba(255,255,255,0.35)" strokeWidth="2.5" data-id="element-725" data-mp="3hqcocc2333b6" />
                              </pattern>
                              <pattern id={`pattern-dots-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-726" data-mp="3csjhrhwvc7ad">
                                <rect width="8" height="8" fill="#10B981" data-id="element-727" data-mp="2k6l6qtpcvo6c" />
                                <circle cx="2" cy="2" r="1.5" fill="rgba(255,255,255,0.45)" data-id="element-728" data-mp="2f702c3rf2nm8" />
                                <circle cx="6" cy="6" r="1.5" fill="rgba(255,255,255,0.45)" data-id="element-729" data-mp="2o99boqay8ay1" />
                              </pattern>
                              <pattern id={`pattern-crosshatch-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-730" data-mp="3byk7dtdfzf5b">
                                <rect width="8" height="8" fill="#DB3725" data-id="element-731" data-mp="3gtptas6ugtte" />
                                <path d="M0,0 l8,8 M8,0 l-8,8" stroke="rgba(255,255,255,0.35)" strokeWidth="2" data-id="element-732" data-mp="s2c85klv7vi7" />
                              </pattern>
                              <pattern id={`pattern-horizontal-${module.module}`} patternUnits="userSpaceOnUse" width="8" height="8" data-id="element-733" data-mp="161bx6tdaicew">
                                <rect width="8" height="8" fill="#F59E0B" data-id="element-734" data-mp="ic13fvucxia9" />
                                <line x1="0" y1="2" x2="8" y2="2" stroke="rgba(255,255,255,0.4)" strokeWidth="2" data-id="element-735" data-mp="n4ar1580269d" />
                                <line x1="0" y1="6" x2="8" y2="6" stroke="rgba(255,255,255,0.4)" strokeWidth="2" data-id="element-736" data-mp="3j8la6gc9st1q" />
                              </pattern>
                            </defs>
                          </svg>
                          {/* Bar */}
                          <div className="h-10 sm:h-12 flex rounded-lg overflow-hidden shadow-sm" data-id="element-737" data-mp="2vi7dudmnk81c">
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.confidentCorrect}%`,
                      backgroundColor: '#007558',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23007558'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} title={`Confident & Correct: ${module.confidentCorrect}%`} data-id="element-738" data-mp="2ql7d8i8knxhm">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#005540'
                      }} data-id="element-739" data-mp="3py1hs03v0i06">
                                {module.confidentCorrect}%
                              </span>
                            </div>
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.uncertainCorrect}%`,
                      backgroundColor: '#10B981'
                    }} title={`Uncertain & Correct: ${module.uncertainCorrect}%`} data-id="element-740" data-mp="32ablp12jfmxm">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#0a8a5e'
                      }} data-id="element-741" data-mp="3avb932s4ocdx">
                                {module.uncertainCorrect}%
                              </span>
                            </div>
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.confidentIncorrect}%`,
                      backgroundColor: '#DB3725',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23DB3725'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} title={`Confident & Incorrect: ${module.confidentIncorrect}%`} data-id="element-742" data-mp="1uk773g54rbf4">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#b02d1e'
                      }} data-id="element-743" data-mp="2zjvtvjx6wd9z">
                                {module.confidentIncorrect}%
                              </span>
                            </div>
                            <div className="flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90 overflow-hidden" style={{
                      width: `${module.uncertainIncorrect}%`,
                      backgroundColor: '#F87171'
                    }} title={`Uncertain & Incorrect: ${module.uncertainIncorrect}%`} data-id="element-744" data-mp="1f11q22untkqk">
                              <span className="whitespace-nowrap hidden sm:inline rounded px-1.5 py-0.5 text-white font-bold text-xs" style={{
                        backgroundColor: '#c44a4a'
                      }} data-id="element-745" data-mp="119wx1jlsrqp7">
                                {module.uncertainIncorrect}%
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Legend Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 sm:gap-y-5" data-id="element-746" data-mp="2f75euel4lsm8">
                          {/* Confident & Correct */}
                          <div className="flex items-center gap-3" data-id="element-747" data-mp="2p6cux9j8w1d1">
                            <span className="text-sm font-bold text-[#007558] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-748" data-mp="2p64ghd7h4nzq">
                              {module.confidentCorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23007558'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} data-id="element-749" data-mp="2y0rgftudc84l"></div>
                            <div className="flex-1 min-w-0" data-id="element-750" data-mp="3mjkuev0klhrd">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-751" data-mp="3mi02ze9jyexq">
                                Confident & Correct
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-752" data-mp="3cmf3bmryhqr5">
                                True mastery
                              </p>
                            </div>
                          </div>

                          {/* Uncertain & Correct */}
                          <div className="flex items-center gap-3" data-id="element-753" data-mp="2ovauqmo9b63f">
                            <span className="text-sm font-bold text-[#10B981] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-754" data-mp="2oy5eebzg4mvs">
                              {module.uncertainCorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundColor: '#10B981'
                    }} data-id="element-755" data-mp="25zu16wr36jmw"></div>
                            <div className="flex-1 min-w-0" data-id="element-756" data-mp="1vz9zxu3khf4o">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-757" data-mp="2tntspyw82e2j">
                                Uncertain & Correct
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-758" data-mp="2jqfm0r03p3nf">
                                Lucky guesses
                              </p>
                            </div>
                          </div>

                          {/* Confident & Incorrect */}
                          <div className="flex items-center gap-3" data-id="element-759" data-mp="13cyw8aknyy3n">
                            <span className="text-sm font-bold text-[#DB3725] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-760" data-mp="13etlu26vree2">
                              {module.confidentIncorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='8' fill='%23DB3725'/%3E%3Cpath d='M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4' stroke='rgba(255,255,255,0.35)' stroke-width='2.5'/%3E%3C/svg%3E")`
                    }} data-id="element-761" data-mp="3oy8ge2v0swzs"></div>
                            <div className="flex-1 min-w-0" data-id="element-762" data-mp="gi6q44zv4wbr">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-763" data-mp="ggcbt9j3k2gn">
                                Confident & Incorrect
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-764" data-mp="2ial5awb0vmoh">
                                Misinformation
                              </p>
                            </div>
                          </div>

                          {/* Uncertain & Incorrect */}
                          <div className="flex items-center gap-3" data-id="element-765" data-mp="xqprle37qdox">
                            <span className="text-sm font-bold text-[#F87171] flex-shrink-0 w-10 text-right tabular-nums" data-id="element-766" data-mp="ssxum5npo1dv">
                              {module.uncertainIncorrect}%
                            </span>
                            <div className="w-6 h-6 rounded flex-shrink-0" style={{
                      backgroundColor: '#F87171'
                    }} data-id="element-767" data-mp="4sejw7lr0kd"></div>
                            <div className="flex-1 min-w-0" data-id="element-768" data-mp="1qgetrurnsjs4">
                              <span className="text-xs font-semibold text-gray-800" data-id="element-769" data-mp="1qelj84dxdfeu">
                                Uncertain & Incorrect
                              </span>
                              <p className="text-[11px] text-gray-500 leading-tight" data-id="element-770" data-mp="1sztdfns4lyxp">
                                Needs practice
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>) : <div className="text-center py-8 text-gray-500" data-id="element-771" data-mp="2brcbdg7ammsv">
                    No data available for the selected skill.
                  </div>}
              </div>
            </div>}
        </div>
      </div>

      {/* Performance Table Section */}
      <div data-phoebe-tour="analytics-table" className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-visible mb-6" data-id="element-772" data-mp="22wxy1j6bpmce">
        <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200 overflow-visible" data-id="element-773" data-mp="2upomv8log8rm">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-id="element-774" data-mp="2zgolqjecx0wr">
            <div data-id="element-775" data-mp="30aicgp0cpc2">
              <div className="flex items-center gap-2" data-id="element-776" data-mp="2zra5rp5tfb8">
                <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-777" data-mp="32dhprc1vutg">
                  <Award size={22} className="text-[#30718D]" data-id="element-778" data-mp="7wr5p8oduzo3" />
                  Performance Table
                </h4>
                <AIInsightPopover align="left" headline="A small group is driving most of the score gap" insightBeforeMetric="There are" highlightedMetric="3 learners" insightAfterMetric=" still below the 70% pass threshold." explanation="Supporting this group first would lift the overall average faster than a broad intervention." insightId={11} data-id="element-779" data-mp="3u624z63ktju4" />
              </div>
              <p className="text-sm text-gray-500 ml-[26px]" data-id="element-780" data-mp="14oup650unxgg">
                Learner performance by selected metric
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3" data-id="element-781" data-mp="19he538n0f4of">
              {/* Learner search dropdown */}
              <div className="relative" ref={performanceLearnerDropdownRef} data-id="element-782" data-mp="2p7x6ng7btzc4">
                <button onClick={() => {
                setIsPerformanceLearnerDropdownOpen(!isPerformanceLearnerDropdownOpen);
                setPerformanceLearnerSearch('');
              }} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[220px]" data-id="element-783" data-mp="33wbgib35uo26">
                  <UsersRound size={16} className="text-[#30718D]" data-id="element-784" data-mp="2k5zic7k2kecb" />
                  <span className="flex-1 text-left truncate" data-id="element-785" data-mp="2g55ufe6mmzjf">
                    {performanceLearnerFilter}
                  </span>
                  <ChevronDown size={16} className={`transition-transform text-gray-500 ${isPerformanceLearnerDropdownOpen ? 'rotate-180' : ''}`} data-id="element-786" data-mp="3rlw1ezivjve3" />
                </button>

                {isPerformanceLearnerDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full sm:w-[280px] bg-white border border-gray-200 rounded-lg shadow-lg z-20" data-id="element-787" data-mp="2tbw8bcy2mnju">
                    <div className="p-2 border-b border-gray-100" data-id="element-788" data-mp="329q0qcspsx1q">
                      <div className="relative" data-id="element-789" data-mp="25kqrovkb3r8h">
                        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-790" data-mp="25m1vgvdr4yzl" />
                        <input type="text" autoFocus value={performanceLearnerSearch} onChange={e => setPerformanceLearnerSearch(e.target.value)} placeholder="Search learners..." className="w-full pl-8 pr-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D]/40 focus:border-[#30718D]" data-id="element-791" data-mp="2ejlv5zvyun83" />
                      </div>
                    </div>
                    <div className="max-h-64 overflow-y-auto py-1" data-id="element-792" data-mp="1ad834j93e319">
                      {(() => {
                    const uniqueNames = Array.from(new Set(performanceTableData.map(r => r.name))).sort((a, b) => a.localeCompare(b));
                    const options = ['All Learners', ...uniqueNames];
                    const q = performanceLearnerSearch.trim().toLowerCase();
                    const filtered = q ? options.filter(n => n.toLowerCase().includes(q)) : options;
                    if (filtered.length === 0) {
                      return <div className="px-4 py-3 text-sm text-gray-500" data-id="element-793" data-mp="cpza836rhrp8">
                              No learners found
                            </div>;
                    }
                    return filtered.map(name => <button key={name} onClick={() => {
                      setPerformanceLearnerFilter(name);
                      setIsPerformanceLearnerDropdownOpen(false);
                      setPerformanceLearnerSearch('');
                      setPerformancePage(1);
                    }} className={`w-full px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm ${performanceLearnerFilter === name ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-794" data-mp="22zjl7vfc28tq">
                            {name}
                          </button>);
                  })()}
                    </div>
                  </div>}
              </div>

              <div className="relative" ref={leaderboardMetricDropdownRef} data-id="element-795" data-mp="12s4s9irier6f">
                <button onClick={() => setIsLeaderboardMetricDropdownOpen(!isLeaderboardMetricDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-796" data-mp="12q1sw84gvlp1">
                  <BarChart3 size={16} className="text-[#30718D]" data-id="element-797" data-mp="20fwqmg2azyfl" />
                  <span className="flex-1 text-left" data-id="element-798" data-mp="1vgk4jxj9ave2">
                    {selectedLeaderboardMetric}
                  </span>
                  <ChevronDown size={16} className={`transition-transform text-gray-500 ${isLeaderboardMetricDropdownOpen ? 'rotate-180' : ''}`} data-id="element-799" data-mp="613yws4jjrsx" />
                </button>

                {isLeaderboardMetricDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-800" data-mp="us01vq6qqznt">
                    {['Average Score', 'Total Assessments', 'Completion Rate', 'Mastery Level'].map(metric => <button key={metric} onClick={() => {
                  setSelectedLeaderboardMetric(metric);
                  setIsLeaderboardMetricDropdownOpen(false);
                }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedLeaderboardMetric === metric ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-801" data-mp="19pae51r7k9kl">
                        {metric}
                      </button>)}
                  </div>}
              </div>

              <div className="relative" ref={leaderboardSkillDropdownRef} data-id="element-802" data-mp="3cwhsd0fxcw5k">
                <button onClick={() => setIsLeaderboardSkillDropdownOpen(!isLeaderboardSkillDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-803" data-mp="3800zxu1ozvmo">
                  <Target size={16} className="text-[#30718D]" data-id="element-804" data-mp="3qvr5fr8u3a5b" />
                  <span className="flex-1 text-left" data-id="element-805" data-mp="3lxpphf6pfqy2">
                    {selectedLeaderboardSkill}
                  </span>
                  <ChevronDown size={16} className={`transition-transform text-gray-500 ${isLeaderboardSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-806" data-mp="na1w9wrok8pv" />
                </button>

                {isLeaderboardSkillDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-807" data-mp="3rrd5ktjkvkkc">
                    {skillOptions.map(skill => <button key={skill} onClick={() => {
                  setSelectedLeaderboardSkill(skill);
                  setIsLeaderboardSkillDropdownOpen(false);
                }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedLeaderboardSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-808" data-mp="3izb916cmqofc">
                        {skill}
                      </button>)}
                  </div>}
              </div>
            </div>
          </div>
        </div>

        {/* Performance Table List */}
        {(() => {
        const parsePct = (v: string | number) => {
          if (typeof v === 'number') return v;
          const cleaned = String(v).replace('%', '').replace('+', '').trim();
          const n = parseFloat(cleaned);
          return isNaN(n) ? 0 : n;
        };
        const learnerFilteredPerf = performanceLearnerFilter === 'All Learners' ? performanceTableData : performanceTableData.filter(r => r.name === performanceLearnerFilter);
        const sortedPerf = [...learnerFilteredPerf].sort((a, b) => {
          const key = performanceSortKey;
          const valA = a[key];
          const valB = b[key];
          if (key === 'name') {
            const strA = String(valA).toLowerCase();
            const strB = String(valB).toLowerCase();
            return performanceSortDir === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
          }
          const numA = parsePct(valA as any);
          const numB = parsePct(valB as any);
          return performanceSortDir === 'asc' ? numA - numB : numB - numA;
        });
        const totalPages = Math.max(1, Math.ceil(sortedPerf.length / performancePerPage));
        const safePage = Math.min(performancePage, totalPages);
        const paginated = sortedPerf.slice((safePage - 1) * performancePerPage, safePage * performancePerPage);
        const isActive = (key: PerformanceTableSortKey) => performanceSortKey === key;
        const SortArrow = ({
          columnKey
        }: {
          columnKey: PerformanceTableSortKey;
        }) => {
          if (!isActive(columnKey)) {
            return <ChevronsUpDown size={14} className="text-gray-400" data-id="element-809" data-mp="2z0rnbcr8cdek" />;
          }
          return performanceSortDir === 'asc' ? <ChevronUp size={14} className="text-[#30718D]" data-id="element-810" data-mp="1ellgj4tcspem" /> : <ChevronDown size={14} className="text-[#30718D]" data-id="element-811" data-mp="1jjd8fyu00bit" />;
        };
        const headerBtnClass = (columnKey: PerformanceTableSortKey) => `flex items-center gap-1 text-left text-sm font-medium transition-colors ${isActive(columnKey) ? 'text-[#30718D]' : 'text-gray-700 hover:text-gray-900'}`;
        const cellActiveClass = (columnKey: PerformanceTableSortKey) => isActive(columnKey) ? 'bg-[#30718D]/5' : '';
        const headerActiveClass = (columnKey: PerformanceTableSortKey) => isActive(columnKey) ? 'bg-[#30718D]/10' : '';
        return <div className="overflow-x-auto" data-id="element-812" data-mp="2b9892rnb3nms">
              <table className="w-full text-sm" data-id="element-813" data-mp="cuwuw3i2qxv6">
                <thead data-id="element-814" data-mp="cw7xw13p41l8">
                  <tr className="border-b border-gray-200 bg-gray-50" data-id="element-815" data-mp="cwrhrncwp01w">
                    <th className="text-left px-4 sm:px-6 py-3 whitespace-nowrap w-12" data-id="element-816" data-mp="gwa1wgwwl73o">
                      <span className="text-sm font-medium text-gray-700" data-id="element-817" data-mp="1k7fs0diegod9">
                        #
                      </span>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('name')}`} data-id="element-818" data-mp="1t7cc01tugz1z">
                      <button onClick={() => handlePerformanceSort('name')} className={headerBtnClass('name')} data-id="element-819" data-mp="1p8d9envl5edp">
                        Learner Name
                        <SortArrow columnKey="name" data-id="element-820" data-mp="2cvbkf60xru48" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('finalScore')}`} data-id="element-821" data-mp="27vyozww01eq1">
                      <button onClick={() => handlePerformanceSort('finalScore')} className={headerBtnClass('finalScore')} data-id="element-822" data-mp="2gx6o2h6cajl6">
                        Final Score
                        <SortArrow columnKey="finalScore" data-id="element-823" data-mp="35ib8u5cxtbt5" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('improvement')}`} data-id="element-824" data-mp="2rhifvp2aaos5">
                      <button onClick={() => handlePerformanceSort('improvement')} className={headerBtnClass('improvement')} data-id="element-825" data-mp="2hs7bgfqce8al">
                        Improvement Rate
                        <SortArrow columnKey="improvement" data-id="element-826" data-mp="27w44mwkjplhb" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 whitespace-nowrap transition-colors ${headerActiveClass('attempts')}`} data-id="element-827" data-mp="2cr1ci0639osm">
                      <button onClick={() => handlePerformanceSort('attempts')} className={headerBtnClass('attempts')} data-id="element-828" data-mp="23rwf4x69k1i1">
                        Attempts
                        <SortArrow columnKey="attempts" data-id="element-829" data-mp="1m26wr6f9oi90" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 max-w-[180px] transition-colors ${headerActiveClass('confidentCorrect')}`} data-id="element-830" data-mp="1i0v2gnlg78uh">
                      <button onClick={() => handlePerformanceSort('confidentCorrect')} className={`${headerBtnClass('confidentCorrect')} items-start text-left`} data-id="element-831" data-mp="1cz5u5fpm19a3">
                        <span className="leading-snug" data-id="element-832" data-mp="z3tzf8bgfit6">
                          Confident & Correct Rate
                        </span>
                        <SortArrow columnKey="confidentCorrect" data-id="element-833" data-mp="2tf8pxrcahm9z" />
                      </button>
                    </th>
                    <th className={`text-left px-4 sm:px-6 py-3 max-w-[180px] transition-colors ${headerActiveClass('confidentIncorrect')}`} data-id="element-834" data-mp="f6y2rkyezj62">
                      <button onClick={() => handlePerformanceSort('confidentIncorrect')} className={`${headerBtnClass('confidentIncorrect')} items-start text-left`} data-id="element-835" data-mp="oxk8mngbwvbk">
                        <span className="leading-snug" data-id="element-836" data-mp="17pzogz4rqwl">
                          Confident & Incorrect Rate
                        </span>
                        <SortArrow columnKey="confidentIncorrect" data-id="element-837" data-mp="589wfjfsksi7" />
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-838" data-mp="1gprqtsbhgfs2">
                  {paginated.map((row, idx) => {
                const rank = (safePage - 1) * performancePerPage + idx + 1;
                return <tr key={`${row.name}-${idx}`} className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors" data-id="element-839" data-mp="3hqojwtp1hwjh" data-mpi={idx}>
                        <td className="px-4 sm:px-6 py-4 text-gray-400 tabular-nums align-middle" data-id="element-840" data-mp="3rpnkrq3kcnvx">
                          {rank}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 font-medium text-gray-900 align-middle whitespace-nowrap transition-colors ${cellActiveClass('name')}`} data-id="element-841" data-mp="3mohqhnu98ska">
                          {row.name}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('finalScore')}`} data-id="element-842" data-mp="38rui8owuqfz2">
                          {row.finalScore}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('improvement')}`} data-id="element-843" data-mp="2bavpn5f192ix">
                          {row.improvement}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('attempts')}`} data-id="element-844" data-mp="htzopjvw41hi">
                          {row.attempts}
                        </td>
                        <td className={`px-4 sm:px-6 py-4 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('confidentCorrect')}`} data-id="element-845" data-mp="1ehe37bhzhocw">
                          <span className="text-[#30718D] font-medium" data-id="element-846" data-mp="15g69l6qexbp5">
                            {row.confidentCorrect}
                          </span>
                        </td>
                        <td className={`px-4 sm:px-6 py-4 text-gray-700 align-middle tabular-nums whitespace-nowrap transition-colors ${cellActiveClass('confidentIncorrect')}`} data-id="element-847" data-mp="3q90175ind1k4">
                          {row.confidentIncorrect}
                        </td>
                      </tr>;
              })}
                </tbody>
              </table>

              {/* Pagination */}
              {sortedPerf.length > 0 && <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-t border-gray-200" data-id="element-848" data-mp="14fllhw2o4jgy">
                  <p className="text-sm text-gray-600" data-id="element-849" data-mp="zibuwd3jm1rj">
                    Showing {(safePage - 1) * performancePerPage + 1}–
                    {Math.min(safePage * performancePerPage, sortedPerf.length)}{' '}
                    of {sortedPerf.length}
                  </p>
                  <div className="flex items-center gap-2" data-id="element-850" data-mp="1n8fxqi8wpxhh">
                    <span className="text-sm text-gray-600" data-id="element-851" data-mp="1igxzi1y9qb07">Page</span>
                    <div className="relative" ref={performancePageDropdownRef} data-id="element-852" data-mp="1iel70uuvwi8w">
                      <button type="button" onClick={() => setIsPerformancePageDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isPerformancePageDropdownOpen} aria-label="Select page" className={`flex min-w-14 items-center justify-between rounded-md border bg-white py-1 pl-2 pr-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${isPerformancePageDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 text-[#30718D]' : 'border-gray-300 text-gray-700'}`} data-id="element-853" data-mp="1ptdpvfosgjea">
                        <span data-id="element-854" data-mp="2sexpvyq14r4u">{safePage}</span>
                        <ChevronDown size={14} aria-hidden="true" className={`ml-2 text-gray-400 transition-transform ${isPerformancePageDropdownOpen ? 'rotate-180' : ''}`} data-id="element-855" data-mp="2sfz4uea61xru" />
                      </button>
                      {isPerformancePageDropdownOpen && <div role="listbox" aria-label="Select page" className="absolute bottom-full z-30 mb-1 max-h-60 min-w-full overflow-y-auto overflow-x-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-856" data-mp="9on5me49jt5d">
                          {Array.from({
                    length: totalPages
                  }, (_, i) => i + 1).map(page => <button key={page} type="button" role="option" aria-selected={safePage === page} onClick={() => {
                    setPerformancePage(page);
                    setIsPerformancePageDropdownOpen(false);
                  }} className={`flex w-full items-center border-b border-gray-100 px-3 py-2 text-left text-sm transition-colors last:border-b-0 ${safePage === page ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-857" data-mp="xgk6ja66d0rp">
                              {page}
                            </button>)}
                        </div>}
                    </div>
                    <span className="text-sm text-gray-600" data-id="element-858" data-mp="2vwkmw42u4vrw">
                      of {totalPages}
                    </span>
                  </div>
                </div>}
            </div>;
      })()}
      </div>
      {/* End Performance Table Section */}
    </>;
}
function IndividualView({
  learner,
  modulePerformance,
  actionItems,
  COLORS,
  selectedSkill,
  setSelectedSkill,
  isSkillDropdownOpen,
  setIsSkillDropdownOpen,
  skillDropdownRef,
  skillOptions,
  selectedLearner,
  setSelectedLearner,
  selectedLearnerData,
  isLearnerDropdownOpen,
  setIsLearnerDropdownOpen,
  learnerDropdownRef
}) {
  // Filter action items for this specific learner (only non-macro items have learner property)
  const learnerActions = actionItems.filter(item => item.learner && (item.learner.name === learner.name || item.learner.email === learner.email));
  // Filter module performance based on selected skill
  const filteredModulePerformance = selectedSkill === 'All Skills Combined' ? modulePerformance : modulePerformance.filter(m => m.module === selectedSkill);
  // Modal states
  const [messageModal, setMessageModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [meetingModal, setMeetingModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  const [kudosModal, setKudosModal] = useState<{
    isOpen: boolean;
    item: any | null;
  }>({
    isOpen: false,
    item: null
  });
  // Get recipient name for modals
  const getRecipientName = (item: any) => {
    if (item.learner) return item.learner.name;
    return 'Team';
  };
  const getRecipientFirstName = (item: any) => {
    if (item.learner) return item.learner.name.split(' ')[0];
    return 'Team';
  };
  // Learner-specific skill data for badges, certificates, assessments, scores, and dates
  const learnerSkillData = {
    // Linda Taylor (id: 1)
    1: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 2,
        avgScore: 92,
        lastAttempt: '2024-01-12'
      },
      'CSS Fundamentals': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 85,
        lastAttempt: '2024-01-10'
      },
      'JavaScript Basics': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 3,
        avgScore: 78,
        lastAttempt: '2024-01-15'
      },
      'Responsive Design': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 88,
        lastAttempt: '2024-01-08'
      }
    },
    // John Smith (id: 2)
    2: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 75,
        lastAttempt: '2024-01-11'
      },
      'CSS Fundamentals': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 62,
        lastAttempt: '2024-01-13'
      },
      'JavaScript Basics': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 3,
        avgScore: 58,
        lastAttempt: '2024-01-14'
      },
      'Responsive Design': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 70,
        lastAttempt: '2024-01-09'
      }
    },
    // Sarah Johnson (id: 3)
    3: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 96,
        lastAttempt: '2024-01-10'
      },
      'CSS Fundamentals': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 94,
        lastAttempt: '2024-01-12'
      },
      'JavaScript Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 95,
        lastAttempt: '2024-01-14'
      },
      'Responsive Design': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 1,
        avgScore: 97,
        lastAttempt: '2024-01-16'
      }
    },
    // Michael Chen (id: 4)
    4: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 82,
        lastAttempt: '2024-01-08'
      },
      'CSS Fundamentals': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 3,
        avgScore: 65,
        lastAttempt: '2024-01-13'
      },
      'JavaScript Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 80,
        lastAttempt: '2024-01-11'
      },
      'Responsive Design': {
        badgeEarned: false,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 72,
        lastAttempt: '2024-01-06'
      }
    },
    // Emily Davis (id: 5)
    5: {
      'HTML Basics': {
        badgeEarned: true,
        certificateAchieved: true,
        assessments: 2,
        avgScore: 88,
        lastAttempt: '2024-01-15'
      },
      'CSS Fundamentals': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 90,
        lastAttempt: '2024-01-12'
      },
      'JavaScript Basics': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 2,
        avgScore: 85,
        lastAttempt: '2024-01-14'
      },
      'Responsive Design': {
        badgeEarned: true,
        certificateAchieved: false,
        assessments: 1,
        avgScore: 91,
        lastAttempt: '2024-01-10'
      }
    }
  };
  // Get skill-specific data for current learner
  const currentLearnerSkillData = learnerSkillData[learner.id] || learnerSkillData[1];
  const currentSkillData = selectedSkill !== 'All Skills Combined' ? currentLearnerSkillData[selectedSkill] : null;
  // Learner-specific progress data for charts - different data for each learner
  const learnerProgressData = {
    // Linda Taylor (id: 1) - Strong performer with steady improvement
    1: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 72
        }, {
          attempt: 'Attempt 2',
          score: 85
        }, {
          attempt: 'Attempt 3',
          score: 92
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 68
        }, {
          attempt: 'Attempt 2',
          mastery: 78
        }, {
          attempt: 'Attempt 3',
          mastery: 88
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 85
        }, {
          attempt: 'Attempt 2',
          score: 92
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 88
        }, {
          attempt: 'Attempt 2',
          mastery: 95
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 85
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 88
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 62
        }, {
          attempt: 'Attempt 2',
          score: 70
        }, {
          attempt: 'Attempt 3',
          score: 78
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 55
        }, {
          attempt: 'Attempt 2',
          mastery: 65
        }, {
          attempt: 'Attempt 3',
          mastery: 75
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 88
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 90
        }]
      }
    },
    // John Smith (id: 2) - Struggling learner with declining scores in some areas
    2: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 65
        }, {
          attempt: 'Attempt 2',
          score: 68
        }, {
          attempt: 'Attempt 3',
          score: 72
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 55
        }, {
          attempt: 'Attempt 2',
          mastery: 60
        }, {
          attempt: 'Attempt 3',
          mastery: 65
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 68
        }, {
          attempt: 'Attempt 2',
          score: 75
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 62
        }, {
          attempt: 'Attempt 2',
          mastery: 72
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 55
        }, {
          attempt: 'Attempt 2',
          score: 62
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 48
        }, {
          attempt: 'Attempt 2',
          mastery: 58
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 68
        }, {
          attempt: 'Attempt 2',
          score: 65
        }, {
          attempt: 'Attempt 3',
          score: 58
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 60
        }, {
          attempt: 'Attempt 2',
          mastery: 55
        }, {
          attempt: 'Attempt 3',
          mastery: 50
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 70
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 65
        }]
      }
    },
    // Sarah Johnson (id: 3) - High performer, first-attempt success
    3: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 95
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 94
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 96
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 95
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 94
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 92
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 95
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 93
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 97
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 96
        }]
      }
    },
    // Michael Chen (id: 4) - Mixed performance, struggles with CSS
    4: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 70
        }, {
          attempt: 'Attempt 2',
          score: 75
        }, {
          attempt: 'Attempt 3',
          score: 78
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 62
        }, {
          attempt: 'Attempt 2',
          mastery: 68
        }, {
          attempt: 'Attempt 3',
          mastery: 72
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 75
        }, {
          attempt: 'Attempt 2',
          score: 82
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 70
        }, {
          attempt: 'Attempt 2',
          mastery: 80
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 52
        }, {
          attempt: 'Attempt 2',
          score: 58
        }, {
          attempt: 'Attempt 3',
          score: 65
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 45
        }, {
          attempt: 'Attempt 2',
          mastery: 52
        }, {
          attempt: 'Attempt 3',
          mastery: 60
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 72
        }, {
          attempt: 'Attempt 2',
          score: 80
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 68
        }, {
          attempt: 'Attempt 2',
          mastery: 78
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 72
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 68
        }]
      }
    },
    // Emily Davis (id: 5) - Good performer with significant improvement
    5: {
      'All Skills Combined': {
        score: [{
          attempt: 'Attempt 1',
          score: 65
        }, {
          attempt: 'Attempt 2',
          score: 88
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 60
        }, {
          attempt: 'Attempt 2',
          mastery: 85
        }]
      },
      'HTML Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 65
        }, {
          attempt: 'Attempt 2',
          score: 88
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 60
        }, {
          attempt: 'Attempt 2',
          mastery: 92
        }]
      },
      'CSS Fundamentals': {
        score: [{
          attempt: 'Attempt 1',
          score: 90
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 88
        }]
      },
      'JavaScript Basics': {
        score: [{
          attempt: 'Attempt 1',
          score: 78
        }, {
          attempt: 'Attempt 2',
          score: 85
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 72
        }, {
          attempt: 'Attempt 2',
          mastery: 82
        }]
      },
      'Responsive Design': {
        score: [{
          attempt: 'Attempt 1',
          score: 91
        }],
        mastery: [{
          attempt: 'Attempt 1',
          mastery: 89
        }]
      }
    }
  };
  // Get the appropriate data for the selected learner and skill
  const currentLearnerProgressData = learnerProgressData[learner.id] || learnerProgressData[1];
  const currentSkillProgressData = currentLearnerProgressData[selectedSkill] || currentLearnerProgressData['All Skills Combined'];
  const scoreProgressData = currentSkillProgressData.score;
  const masteryProgressData = currentSkillProgressData.mastery;
  return <>
      {/* Learner Header */}
      <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 mb-6" data-id="element-859" data-mp="cwyx329vue0v">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-860" data-mp="80i7s4qy5tm7">
          <div className="flex items-center gap-4" data-id="element-861" data-mp="mxj28g0iw2od">
            <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#30718D] flex items-center justify-center text-white text-lg sm:text-xl font-bold shadow-sm" data-id="element-862" data-mp="mu3hoxo2y1fk">
              {learner.name.split(' ').map(n => n[0]).join('')}
            </div>
            <div data-id="element-863" data-mp="15iffr4xut329">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-864" data-mp="rl8xdbh1l6dk">
                {learner.name}
              </h2>
              <p className="text-gray-600 text-sm" data-id="element-865" data-mp="wj0r8b18z2ke">{learner.email}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3" data-id="element-866" data-mp="hu4j6dz6xpjs">
            {/* Badge - Conditional based on skill selection */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-867" data-mp="8uhjpxq0uttd">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-868" data-mp="dtc8dgao7cle">
                {currentSkillData ? 'Badge Earned' : 'Badges Earned'}
              </div>
              {currentSkillData ? <div className={`text-base sm:text-lg font-bold ${currentSkillData.badgeEarned ? 'text-[#007558]' : 'text-gray-400'}`} data-id="element-869" data-mp="3v4tr43ut6mk">
                  {currentSkillData.badgeEarned ? 'Yes' : 'No'}
                </div> : <div className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-870" data-mp="35p5kmkw5t50e">
                  12
                </div>}
            </div>

            {/* Certificate - Conditional based on skill selection */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-871" data-mp="2i1dy6ogwnble">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-872" data-mp="2msvwt5vgh037">
                {currentSkillData ? 'Certificate Achieved' : 'Certificates Achieved'}
              </div>
              {currentSkillData ? <div className={`text-base sm:text-lg font-bold ${currentSkillData.certificateAchieved ? 'text-[#007558]' : 'text-gray-400'}`} data-id="element-873" data-mp="2d0q4tw57eio0">
                  {currentSkillData.certificateAchieved ? 'Yes' : 'No'}
                </div> : <div className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-874" data-mp="1kigrhda2ydh2">
                  3
                </div>}
            </div>

            {/* Total Assessments - Updates based on skill */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-875" data-mp="1ohxxq8xbzena">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-876" data-mp="23eytcnin7tr1">
                Total Assessments
              </div>
              <div className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-877" data-mp="1yf2n0hmh3q8b">
                {currentSkillData ? currentSkillData.assessments : learner.assessments}
              </div>
            </div>

            {/* Average Score - Updates based on skill */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-878" data-mp="2m4wvkmzresmr">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-879" data-mp="2h7y46c7hczs9">
                Average Score
              </div>
              <div className="text-xl sm:text-2xl font-bold text-[#30718D]" data-id="element-880" data-mp="1ev1xjdbzum0x">
                {currentSkillData ? currentSkillData.avgScore : learner.avgScore}
                %
              </div>
            </div>

            {/* Last Attempt / Attempted Date - Updates based on skill */}
            <div className="text-center px-3 sm:px-6 py-2 sm:py-3 bg-gray-50 rounded-lg border border-gray-100 col-span-2 sm:col-span-1" data-id="element-881" data-mp="1xjp2zwy31df1">
              <div className="text-xs font-medium text-gray-500 mb-1" data-id="element-882" data-mp="22hqkidfv14oe">
                {currentSkillData ? 'Attempted Date' : 'Last Attempt'}
              </div>
              <div className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-883" data-mp="2bjhmb77a4rcz">
                {currentSkillData ? currentSkillData.lastAttempt : learner.lastAttempt}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Individual Learner Progress Section */}
      <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 mb-6" data-id="element-884" data-mp="9m7kpbxqb3wt">
        <div className="flex items-start justify-between mb-6" data-id="element-885" data-mp="4uxry2gvvkgp">
          <div data-id="element-886" data-mp="3w1ifhc7qca8z">
            <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-887" data-mp="3w18xaasxf7du">
              Individual Learner Progress
            </h3>
            <p className="text-sm text-gray-600" data-id="element-888" data-mp="3r3gvmp2hc6wg">
              Track attempt-by-attempt progress for {learner.name.split(' ')[0]}{' '}
              in {selectedSkill}
            </p>
          </div>
          {selectedSkill !== 'All Skills Combined' && <span className="px-3 py-1 bg-[#30718D]/10 text-[#30718D] rounded-full text-sm font-medium" data-id="element-889" data-mp="imm4u7yyicyq">
              Viewing: {selectedSkill}
            </span>}
        </div>

        {/* Progress Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-890" data-mp="33dcviroi2pa7">
          {/* Score Progress Chart */}
          <div className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-891" data-mp="2zaq770r1fmhr">
            <h4 className="text-base font-bold text-gray-900 text-center mb-6" data-id="element-892" data-mp="r2jp6xhm0fiu">
              Score Progress
            </h4>
            <ResponsiveContainer width="100%" height={400} data-id="element-893" data-mp="vtjna62gt3mx">
              <LineChart data={scoreProgressData} margin={{
              bottom: 20
            }} data-id="element-894" data-mp="vv3889z2g2v1">
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-895" data-mp="m48j8xufqp5w" />
                <XAxis dataKey="attempt" label={{
                value: 'Attempts',
                position: 'insideBottom',
                offset: -10
              }} tick={{
                fontSize: 12
              }} data-id="element-896" data-mp="19sjad9abxagz" />
                <YAxis domain={[0, 100]} label={{
                value: 'Percentage (%)',
                angle: -90,
                position: 'insideLeft'
              }} tick={{
                fontSize: 12
              }} data-id="element-897" data-mp="14sn6rb5jnl1y" />
                <Tooltip data-id="element-898" data-mp="3i2r830qns6nh" />
                <Line type="monotone" dataKey="score" stroke="#30718D" strokeWidth={3} dot={{
                fill: '#30718D',
                r: 6
              }} activeDot={{
                r: 8
              }} data-id="element-899" data-mp="3d1tqoqdh3gn1" />
              </LineChart>
            </ResponsiveContainer>
          </div>

          {/* Mastery Rate Progress Chart */}
          <div className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-900" data-mp="2u991pk0w9voi">
            <h4 className="text-base font-bold text-gray-900 text-center mb-6" data-id="element-901" data-mp="391axarvxm2iq">
              Mastery Rate Progress
            </h4>
            <ResponsiveContainer width="100%" height={400} data-id="element-902" data-mp="2gjp0iimyp6hb">
              <LineChart data={masteryProgressData} margin={{
              bottom: 20
            }} data-id="element-903" data-mp="2ghuh58rc9mfc">
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-904" data-mp="319j8xd66wqgk" />
                <XAxis dataKey="attempt" label={{
                value: 'Attempts',
                position: 'insideBottom',
                offset: -10
              }} tick={{
                fontSize: 12
              }} data-id="element-905" data-mp="35abhs5b5gtcb" />
                <YAxis domain={[0, 100]} label={{
                value: 'Percentage (%)',
                angle: -90,
                position: 'insideLeft'
              }} tick={{
                fontSize: 12
              }} data-id="element-906" data-mp="2iadrun4l2l19" />
                <Tooltip data-id="element-907" data-mp="2wag2boakac6h" />
                <Line type="monotone" dataKey="mastery" stroke="#007558" strokeWidth={3} dot={{
                fill: '#007558',
                r: 6
              }} activeDot={{
                r: 8
              }} data-id="element-908" data-mp="2w7k5k3ag9tjm" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Recommended Actions Section */}
      <AnimatePresence mode="wait" data-id="element-909" data-mp="1m9ala7uiwm40">
        {learnerActions.length > 0 && <motion.div key={learner.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3
      }} className="mb-6" data-id="element-910" data-mp="1hcage09etpeh"></motion.div>}
      </AnimatePresence>

      {/* Individual Module Performance */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-6" data-id="element-911" data-mp="2xq0ve222hy2w">
        <div className="flex items-center justify-between mb-5" data-id="element-912" data-mp="2ss8sye3sqtkg">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-913" data-mp="21m3hhcrfn76u">
            {selectedSkill === 'All Skills Combined' ? 'Module Performance' : `${selectedSkill} Performance`}
          </h3>
          {selectedSkill !== 'All Skills Combined' && <span className="px-3 py-1 bg-[#30718D]/10 text-[#30718D] rounded-full text-sm font-medium" data-id="element-914" data-mp="1wvn5lx39ftml">
              Filtered
            </span>}
        </div>
        <div className="space-y-4" data-id="element-915" data-mp="1iukhlespg991">
          {filteredModulePerformance.length > 0 ? filteredModulePerformance.map((module, index) => <div key={index} className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-916" data-mp="19vz0zp6sn4aw" data-mpi={index}>
                <div className="flex items-center justify-between mb-4" data-id="element-917" data-mp="1dx2i0f0kv6dp">
                  <div data-id="element-918" data-mp="34a9nhqzx1mdi">
                    <h4 className="font-semibold text-base text-gray-900" data-id="element-919" data-mp="349zxi3evff7t">
                      {module.module}
                    </h4>
                    <p className="text-sm text-gray-500 mt-0.5" data-id="element-920" data-mp="wn6xb3re13br">
                      {module.attempts} attempt
                      {module.attempts !== 1 ? 's' : ''}
                    </p>
                  </div>
                  <div className="text-right" data-id="element-921" data-mp="16djfwqfn6mf9">
                    <div className={`text-3xl font-bold ${module.score >= 85 ? 'text-[#007558]' : 'text-[#DB3725]'}`} data-id="element-922" data-mp="16fco4a5wlepd">
                      {module.score}%
                    </div>
                    <div className="flex items-center justify-end gap-1.5 mt-1" data-id="element-923" data-mp="1bccu6l2r6hgh">
                      {module.score >= 85 ? <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-[#007558]/10 text-[#007558]" data-id="element-924" data-mp="1pcdrxrnq18rq">
                          <CheckCircle size={12} data-id="element-925" data-mp="1kb81k0hj9xld" />
                          Passed
                        </span> : <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-[#DB3725]/10 text-[#DB3725]" data-id="element-926" data-mp="3m57c2jmu0ax0">
                          <AlertTriangle size={12} data-id="element-927" data-mp="2xip38wyjjyuy" />
                          Not Passed
                        </span>}
                    </div>
                    <div className="text-xs font-medium text-gray-500 mt-0.5" data-id="element-928" data-mp="2nphv54cf24r6">
                      Highest Assessment Score
                    </div>
                  </div>
                </div>

                {/* Confidence Analysis */}
                <div data-id="element-929" data-mp="29r1g8q4eh7xy">
                  <h5 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-930" data-mp="29qi8214jxxx4">
                    Answer Confidence Breakdown
                  </h5>

                  {/* Stacked Bar Visualization */}
                  <div className="mb-4" data-id="element-931" data-mp="1ztdjjun8hqd5">
                    <div className="h-8 flex rounded-lg overflow-hidden shadow-sm" data-id="element-932" data-mp="1zuezodj3x31q">
                      {/* Confident + Correct */}
                      <div className="bg-[#007558] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.confidentCorrect}%`
                }} title={`Confident & Correct: ${module.confidentCorrect}%`} data-id="element-933" data-mp="3u6va7qixr3ce">
                        {module.confidentCorrect >= 10 && `${module.confidentCorrect}%`}
                      </div>

                      {/* Uncertain + Correct */}
                      <div className="bg-[#10B981] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.uncertainCorrect}%`
                }} title={`Uncertain & Correct: ${module.uncertainCorrect}%`} data-id="element-934" data-mp="3nqczr2e8urfj">
                        {module.uncertainCorrect >= 10 && `${module.uncertainCorrect}%`}
                      </div>

                      {/* Confident + Incorrect */}
                      <div className="bg-[#DB3725] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.confidentIncorrect}%`
                }} title={`Confident & Incorrect: ${module.confidentIncorrect}%`} data-id="element-935" data-mp="3434zyrzcix0i">
                        {module.confidentIncorrect >= 10 && `${module.confidentIncorrect}%`}
                      </div>

                      {/* Uncertain + Incorrect */}
                      <div className="bg-[#F59E0B] flex items-center justify-center text-white text-xs font-bold transition-all duration-500 hover:opacity-90" style={{
                  width: `${module.uncertainIncorrect}%`
                }} title={`Uncertain & Incorrect: ${module.uncertainIncorrect}%`} data-id="element-936" data-mp="2ubr3kt2oydbl">
                        {module.uncertainIncorrect >= 10 && `${module.uncertainIncorrect}%`}
                      </div>
                    </div>
                  </div>

                  {/* Legend Grid */}
                  <div className="grid grid-cols-2 gap-3" data-id="element-937" data-mp="2b876705p0ove">
                    <div className="flex items-start gap-2" data-id="element-938" data-mp="2b8qd7ltt1sun">
                      <div className="w-4 h-4 rounded bg-[#007558] flex-shrink-0 mt-0.5" data-id="element-939" data-mp="2g7thv55vhx23"></div>
                      <div className="flex-1 min-w-0" data-id="element-940" data-mp="21aiy78j2tkva">
                        <div className="flex items-center gap-2" data-id="element-941" data-mp="219rfuzehpjmy">
                          <span className="text-xs font-bold text-[#007558] min-w-[32px]" data-id="element-942" data-mp="2682ox7wynq44">
                            {module.confidentCorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-943" data-mp="uugp8sth664c">
                            Confident & Correct
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-944" data-mp="16amzbklitsni">
                          True mastery
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2" data-id="element-945" data-mp="wcfm9cucruqs">
                      <div className="w-4 h-4 rounded bg-[#10B981] flex-shrink-0 mt-0.5" data-id="element-946" data-mp="wa2u66uvs400"></div>
                      <div className="flex-1 min-w-0" data-id="element-947" data-mp="1tz66fwsu3ze0">
                        <div className="flex items-center gap-2" data-id="element-948" data-mp="1p0l67xdl1fpk">
                          <span className="text-xs font-bold text-[#10B981] min-w-[32px]" data-id="element-949" data-mp="1k1rry2qh1koc">
                            {module.uncertainCorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-950" data-mp="1f4rm9sxjajxr">
                            Uncertain & Correct
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-951" data-mp="3m6z16kymk5c">
                          Lucky guesses
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2" data-id="element-952" data-mp="2ka7xwpevfyw0">
                      <div className="w-4 h-4 rounded bg-[#DB3725] flex-shrink-0 mt-0.5" data-id="element-953" data-mp="2p8rk8qxdncow"></div>
                      <div className="flex-1 min-w-0" data-id="element-954" data-mp="2u01a9smu8i1b">
                        <div className="flex items-center gap-2" data-id="element-955" data-mp="2u1krpmk8cz4o">
                          <span className="text-xs font-bold text-[#DB3725] min-w-[32px]" data-id="element-956" data-mp="2yy2w2lbnevgh">
                            {module.confidentIncorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-957" data-mp="380kgcu7qte0u">
                            Confident & Incorrect
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-958" data-mp="1dmb6kmzmrvs7">
                          Misinformation
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2" data-id="element-959" data-mp="1aj51tgnqxmpu">
                      <div className="w-4 h-4 rounded bg-[#F59E0B] flex-shrink-0 mt-0.5" data-id="element-960" data-mp="1alq2418ebulh"></div>
                      <div className="flex-1 min-w-0" data-id="element-961" data-mp="16ko4fou4nqlm">
                        <div className="flex items-center gap-2" data-id="element-962" data-mp="1kivvxh8e9zpe">
                          <span className="text-xs font-bold text-[#F59E0B] min-w-[32px]" data-id="element-963" data-mp="1figjqszumy90">
                            {module.uncertainIncorrect}%
                          </span>
                          <span className="text-xs font-semibold text-gray-700" data-id="element-964" data-mp="1ph5rvu1y14c2">
                            Uncertain & Incorrect
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-0.5 ml-[40px]" data-id="element-965" data-mp="23aew7gb1aznq">
                          Needs practice
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>) : <div className="text-center py-8 text-gray-500" data-id="element-966" data-mp="285kkglrwsqez">
              No performance data available for {selectedSkill}.
            </div>}
        </div>
      </div>

      {/* Enhanced Mastery Heatmap */}
      <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-967" data-mp="2hv9hsnsfmkzj">
        <div className="mb-6" data-id="element-968" data-mp="2hxncuwn43x73">
          <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-969" data-mp="2mtujysr8veqm">
            Knowledge Mastery Overview
          </h3>
          <p className="text-gray-600 text-sm" data-id="element-970" data-mp="284ewbln0fpf5">
            Visual representation of {learner.name.split(' ')[0]}'s proficiency
            {selectedSkill === 'All Skills Combined' ? ' across all modules' : ` in ${selectedSkill}`}
          </p>
        </div>

        {filteredModulePerformance.length > 0 ? <div className={`grid gap-4 mb-8 ${filteredModulePerformance.length === 1 ? 'grid-cols-1 max-w-xs' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'}`} data-id="element-971" data-mp="241s25e2v9ses">
            {filteredModulePerformance.map((module, index) => {
          const masteryLevel = module.mastery >= 90 ? 'expert' : module.mastery >= 75 ? 'proficient' : module.mastery >= 60 ? 'developing' : 'needs-work';
          const colorConfig = {
            expert: {
              bg: 'from-[#007558] to-[#005a44]',
              border: 'border-[#007558]',
              text: 'text-white',
              icon: '★'
            },
            proficient: {
              bg: 'from-[#30718D] to-[#265a70]',
              border: 'border-[#30718D]',
              text: 'text-white',
              icon: '✓'
            },
            developing: {
              bg: 'from-[#F59E0B] to-[#D97706]',
              border: 'border-[#F59E0B]',
              text: 'text-white',
              icon: '↗'
            },
            'needs-work': {
              bg: 'from-[#DB3725] to-[#b82e1f]',
              border: 'border-[#DB3725]',
              text: 'text-white',
              icon: '!'
            }
          };
          const config = colorConfig[masteryLevel];
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9,
            y: 20
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} transition={{
            delay: index * 0.1,
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} whileHover={{
            scale: 1.05,
            y: -4,
            transition: {
              duration: 0.2
            }
          }} className="group relative cursor-pointer" data-id="element-972" data-mp="17sbxrsnag1sn" data-mpi={index}>
                  <div className={`
                    relative overflow-hidden rounded-xl border-2 ${config.border}
                    bg-gradient-to-br ${config.bg}
                    shadow-md hover:shadow-xl
                    transition-all duration-300
                    aspect-square
                  `} data-id="element-973" data-mp="3vazzr90cpoxp">
                    {/* Shine effect on hover */}
                    <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-974" data-mp="ivz2zm3tdjg4" />

                    {/* Content */}
                    <div className="relative h-full flex flex-col items-center justify-center p-6 text-center" data-id="element-975" data-mp="8vydtjj9k940">
                      {/* Attempts Badge */}
                      <motion.div className="absolute top-3 right-3" initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  delay: index * 0.1 + 0.3,
                  type: 'spring'
                }} data-id="element-976" data-mp="2tm5xviolxjgr">
                        <div className="bg-white/20 backdrop-blur-sm rounded-full px-2.5 py-1" data-id="element-977" data-mp="2y9hla2xndpyb">
                          <span className={`text-xs font-bold ${config.text}`} data-id="element-978" data-mp="32bmckv0miahs">
                            Attempts: {module.attempts}
                          </span>
                        </div>
                      </motion.div>

                      {/* Score */}
                      <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  delay: index * 0.1 + 0.2,
                  type: 'spring',
                  stiffness: 300
                }} className="mb-3" data-id="element-979" data-mp="3h60rokh2gzr6">
                        <div className={`text-5xl font-black ${config.text} drop-shadow-lg`} data-id="element-980" data-mp="1orkm9br5auaw">
                          {module.mastery}%
                        </div>
                      </motion.div>

                      {/* Module Name */}
                      <div className={`text-sm font-bold ${config.text} drop-shadow-md leading-tight px-2`} data-id="element-981" data-mp="1sr1u2bu1o3j8">
                        {module.module}
                      </div>

                      {/* Progress Ring */}
                      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 w-16 h-1 bg-white/30 rounded-full overflow-hidden" data-id="element-982" data-mp="2gge238dmy5jy">
                        <motion.div initial={{
                    width: 0
                  }} animate={{
                    width: `${module.mastery}%`
                  }} transition={{
                    delay: index * 0.1 + 0.4,
                    duration: 0.8
                  }} className="h-full bg-white/90 rounded-full" data-id="element-983" data-mp="2ch557unatrk6" />
                      </div>
                    </div>

                    {/* Hover Tooltip */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl p-6 flex flex-col justify-center bg-white shadow-xl" data-id="element-984" data-mp="2h666uxoneh46">
                      <div className="space-y-3" data-id="element-985" data-mp="27ejpejlpvlsz">
                        <div className="text-base font-bold border-b border-gray-200 pb-2 text-gray-900" data-id="element-986" data-mp="1tdz9pwb3m63p">
                          {module.module}
                        </div>

                        <div className="space-y-2 text-sm" data-id="element-987" data-mp="30r06lcxaosyg">
                          <div className="flex justify-between items-center" data-id="element-988" data-mp="30qi0loktz0dc">
                            <span className="text-gray-600" data-id="element-989" data-mp="2wqhhvrqp830h">
                              Overall Score:
                            </span>
                            <span className="font-bold text-gray-900" data-id="element-990" data-mp="2rwd6mwaeh8tl">
                              {module.score}%
                            </span>
                          </div>

                          <div className="flex justify-between items-center" data-id="element-991" data-mp="2i1tnhosl9zc4">
                            <span className="text-gray-600" data-id="element-992" data-mp="2d0nurqyxic2l">Mastery:</span>
                            <span className="font-bold text-[#007558]" data-id="element-993" data-mp="28z28jf0i8lfq">
                              {module.mastery}%
                            </span>
                          </div>

                          <div className="flex justify-between items-center" data-id="element-994" data-mp="790k9qd2zfs7">
                            <span className="text-gray-600" data-id="element-995" data-mp="29e71gx95zje">
                              Misinformation:
                            </span>
                            <span className="font-bold text-[#DB3725]" data-id="element-996" data-mp="9rvl80g2q2ip">
                              {module.misinformation}%
                            </span>
                          </div>

                          <div className="flex justify-between items-center pt-2 border-t border-gray-200" data-id="element-997" data-mp="jiginkk0h101">
                            <span className="text-gray-600" data-id="element-998" data-mp="ogrshvab3bi9">Attempts:</span>
                            <span className="font-bold text-[#30718D]" data-id="element-999" data-mp="3mzylfdkxfhtl">
                              {module.attempts}
                            </span>
                          </div>
                        </div>

                        <div className="pt-2" data-id="element-1000" data-mp="r5ql02jui6k">
                          <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold border ${masteryLevel === 'expert' ? 'bg-[#007558]/30 text-[#007558] border-[#007558]/50' : masteryLevel === 'proficient' ? 'bg-[#30718D]/30 text-[#30718D] border-[#30718D]/50' : masteryLevel === 'developing' ? 'bg-[#F59E0B]/30 text-[#F59E0B] border-[#F59E0B]/50' : 'bg-[#DB3725]/30 text-[#DB3725] border-[#DB3725]/50'}`} data-id="element-1001" data-mp="ul8eanly5bo">
                            <span data-id="element-1002" data-mp="38cv3awioao6d">{config.icon}</span>
                            <span data-id="element-1003" data-mp="3m98mca2uuxmy">
                              {masteryLevel === 'expert' ? 'Expert Level' : masteryLevel === 'proficient' ? 'Proficient' : masteryLevel === 'developing' ? 'Developing' : 'Needs Focus'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>;
        })}
          </div> : <div className="text-center py-8 text-gray-500" data-id="element-1004" data-mp="25wl775pi01ql">
            No performance data available for {selectedSkill}.
          </div>}

        {/* Enhanced Legend */}
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1005" data-mp="q4pmsx396nen">
          <h4 className="text-sm font-bold text-gray-700 mb-4 uppercase tracking-wide" data-id="element-1006" data-mp="q6tyw2bb2sq0">
            Mastery Levels
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1007" data-mp="hc5u0d9n7d1q">
            <div className="flex items-center gap-3" data-id="element-1008" data-mp="hab9v1673oyp">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#DB3725] to-[#b82e1f] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1009" data-mp="151qckv1vw8ah">
                <span className="text-white font-bold text-lg" data-id="element-1010" data-mp="1918zfwd9mtfy">!</span>
              </div>
              <div data-id="element-1011" data-mp="v5wtstxknik9">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1012" data-mp="102x3detmr3g4">
                  Needs Work
                </div>
                <div className="text-xs text-gray-500" data-id="element-1013" data-mp="3fti5wsc44be9">0-59%</div>
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-1014" data-mp="3ktebgw0gkavx">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#F59E0B] to-[#D97706] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1015" data-mp="3kr1jrr4wem5o">
                <span className="text-white font-bold text-lg" data-id="element-1016" data-mp="bb6v5cswwwrt">↗</span>
              </div>
              <div data-id="element-1017" data-mp="6cc5ps0fw9yq">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1018" data-mp="6dx1fkyhpyy6">
                  Developing
                </div>
                <div className="text-xs text-gray-500" data-id="element-1019" data-mp="1fvf8r5rpjih">60-74%</div>
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-1020" data-mp="z3vs1ksc244y">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#30718D] to-[#265a70] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1021" data-mp="u2g6zsq5nxmk">
                <span className="text-white font-bold text-lg" data-id="element-1022" data-mp="p9n3t9ac4xcl">✓</span>
              </div>
              <div data-id="element-1023" data-mp="katyi457ccni">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1024" data-mp="1hsaleeq4hu8x">
                  Proficient
                </div>
                <div className="text-xs text-gray-500" data-id="element-1025" data-mp="1d127p6hrfmpy">75-89%</div>
              </div>
            </div>

            <div className="flex items-center gap-3" data-id="element-1026" data-mp="1lazvaxql2d8o">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#007558] to-[#005a44] shadow-md flex items-center justify-center flex-shrink-0" data-id="element-1027" data-mp="1lcb1t5bexz3h">
                <span className="text-white font-bold text-lg" data-id="element-1028" data-mp="1u9v0q7lszjax">★</span>
              </div>
              <div data-id="element-1029" data-mp="1za99jrv8axa0">
                <div className="font-bold text-gray-900 text-sm" data-id="element-1030" data-mp="1zaslmry76rg4">Mastery</div>
                <div className="text-xs text-gray-500" data-id="element-1031" data-mp="249vny4msmjke">90-100%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}
function MetricCard({
  icon,
  label,
  value,
  change,
  changeLabel,
  color
}) {
  const colorClasses = {
    blue: 'bg-[#30718D]/10 text-[#30718D]',
    green: 'bg-[#007558]/10 text-[#007558]',
    purple: 'bg-[#30718D]/10 text-[#30718D]',
    orange: 'bg-orange-100 text-orange-600'
  };
  const isPositive = change > 0;
  const isNeutral = change === 0;
  return <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-1032" data-mp="2rzg8grylhovs">
      <div className="flex items-center justify-between mb-2" data-id="element-1033" data-mp="3tq1gxerxzfmc">
        <span className="text-sm font-medium text-gray-600" data-id="element-1034" data-mp="3tsnlr6ng7h0v">{label}</span>
        {isPositive ? <TrendingUp size={20} className="text-green-600" data-id="element-1035" data-mp="2hnek2gbwzaz" /> : isNeutral ? <Minus size={20} className="text-gray-400" data-id="element-1036" data-mp="3krpl8yc7xrn1" /> : <TrendingUp size={20} className="text-red-600 rotate-180" data-id="element-1037" data-mp="3orzoi38mm3y7" />}
      </div>
      <div className="flex items-end justify-between" data-id="element-1038" data-mp="gcg13kumzfr2">
        <div className="text-3xl font-bold text-gray-900" data-id="element-1039" data-mp="lahqsomkidbi">{value}</div>
        <span className={`text-lg font-bold ${isPositive ? 'text-green-600' : isNeutral ? 'text-gray-500' : 'text-red-600'}`} data-id="element-1040" data-mp="l9pu1ah8i9jn">
          {isPositive ? '+' : ''}
          {change}%
        </span>
      </div>
    </div>;
}
function SkillPerformanceHeader({
  selectedInsightSkill,
  setSelectedInsightSkill,
  isInsightSkillDropdownOpen,
  setIsInsightSkillDropdownOpen,
  insightSkillDropdownRef,
  skillOptions
}) {
  return <div className="bg-white px-4 sm:px-6 py-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4" data-id="element-1041" data-mp="2oqw5g8v123wj">
      <div data-id="element-1042" data-mp="2js1g0o2k1h3g">
        <h4 className="text-base font-bold text-gray-900 mb-0.5 flex items-center gap-2" data-id="element-1043" data-mp="2jq8fzrmg5v4f">
          <BarChart3 size={22} className="text-[#30718D]" data-id="element-1044" data-mp="2yjabhdt51woi" />
          Skill Performance
        </h4>
        <p className="text-sm text-gray-500 ml-[26px]" data-id="element-1045" data-mp="2tk7gynasb8us">
          {selectedInsightSkill === 'All Skills Combined' ? 'Detailed metrics for all skills' : `Detailed metrics for ${selectedInsightSkill}`}
        </p>
      </div>
      <div className="relative" ref={insightSkillDropdownRef} data-id="element-1046" data-mp="2fqzpqwqm8fdm">
        <button onClick={() => setIsInsightSkillDropdownOpen(!isInsightSkillDropdownOpen)} className="flex items-center gap-2 px-3 sm:px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-bold text-gray-900 w-full sm:min-w-[200px]" data-id="element-1047" data-mp="2fod8g5dxali7">
          <Target size={16} className="text-[#30718D]" data-id="element-1048" data-mp="3tai1985qpnap" />
          <span className="flex-1 text-left" data-id="element-1049" data-mp="3tc2sansuio3t">{selectedInsightSkill}</span>
          <ChevronDown size={16} className={`transition-transform text-gray-500 ${isInsightSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1050" data-mp="2242e5tc5p43" />
        </button>

        {isInsightSkillDropdownOpen && <div className="absolute top-full mt-2 right-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-1051" data-mp="bzik08qzwjxz">
            {skillOptions.map(skill => <button key={skill} onClick={() => {
          setSelectedInsightSkill(skill);
          setIsInsightSkillDropdownOpen(false);
        }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 text-sm ${selectedInsightSkill === skill ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-1052" data-mp="3fj3dko0w0xxb">
                {skill}
              </button>)}
          </div>}
      </div>
    </div>;
}